<template>
  <div id="contenedor">
    <v-layout row wrap>
      <v-flex xs11 class="offset-half">
        <v-card class="table" elevation="4">
          <v-toolbar flat elevation="4">
            <v-card class="icon">
              <v-icon
                style="margin-left: 30px; margin-top: 25px"
                color="white"
                x-large=""
                >mdi-folder-alert-outline</v-icon
              >
            </v-card>
            <div class="usuario">{{ getTituloVista() }}</div>
            <!-- Botón de actualizar manual -->
            <v-btn
              color="#1D3C7F"
              @click="obtenerCasos"
              class="ml-5 update-btn"
              style="color: white; font-weight: bold"
              :loading="loadingObtenerCasos"
              :disabled="loadingObtenerCasos"
            >
              <template v-if="!loadingObtenerCasos">
                <v-icon size="28px">mdi-refresh</v-icon>
              </template>
              <template v-else>
                <v-progress-circular
                  indeterminate
                  color="white"
                  size="24"
                ></v-progress-circular>
              </template>
            </v-btn>
            <v-spacer></v-spacer>

            <!-- Filtro por empresa (solo para Mesa de Servicios y Sistemas) -->
            <div v-if="mostrarFiltroEmpresa" class="filter-container mr-3">
              <v-select
                v-model="filtroEmpresa"
                :items="opcionesEmpresa"
                item-text="text"
                item-value="value"
                label="Filtrar por empresa"
                outlined
                dense
                style="max-width: 180px; font-size: 13.5px"
                @change="aplicarFiltroEmpresa"
              ></v-select>
            </div>
            <!-- 🟢 Filtro específico para Gestión Humana (solo si el usuario es de Facilisimo) -->
            <div v-if="idAreaUsuario === 3 && idEmpresaUsuario === 1" class="filter-container mr-3">
              <v-select
                v-model="filtroGestionHumana"
                :items="opcionesGestionHumana"
                item-text="text"
                item-value="value"
                label="Filtrar por"
                outlined
                dense
                style="max-width: 150px; font-size: 13.5px"
                @change="aplicarFiltroGestionHumana"
              ></v-select>
            </div>

            <!-- Filtro para cambiar vista -->
            <div class="filter-container">
              <!-- Select normal para pantallas grandes -->
              <v-select
                v-if="!$vuetify.breakpoint.xs"
                v-model="selectedFilter"
                :items="filterOptions"
                item-text="text"
                item-value="value"
                label="Cambiar vista"
                outlined
                dense
                style="max-width: 150px; font-size: 13.5px"
                @change="changeFilter"
              ></v-select>

              <!-- Solo icono para pantallas pequeñas -->
              <v-menu
                v-if="$vuetify.breakpoint.xs"
                v-model="showFilterMenu"
                :close-on-content-click="false"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" class="filter-icon-btn">
                    <v-icon>mdi-filter-variant</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="option in filterOptions"
                    :key="option.value"
                    @click="selectFilterOption(option.value)"
                  >
                    <v-list-item-title>{{ option.text }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </v-toolbar>

          <br />
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="getLabelBusqueda()"
            class="text-field"
            single-line
            color="#111c3d"
          ></v-text-field>
          <br />
          <v-data-table
            :headers="headers"
            :items="casosVisualizar"
            :search="search"
            v-model="casosSeleccionados"
            show-select
            item-key="cc_id_caso"
            :item-class="getItemClass"
            :selectable="isSelectable"
            style="border: 2px solid #111c3d"
            class="elevation-3"
            must-sort
          >
            <template v-slot:footer.prepend>
              <v-btn
                color="#1D3C7F"
                class="acciones-masivas-btn"
                :disabled="!puedeRealizarAccionMasiva"
                @click="abrirModalAccionMasiva"
                style="color: whitesmoke; font-weight: bold"
                large
              >
                <v-icon left style="color: whitesmoke"
                  >mdi-playlist-edit</v-icon
                >
                ACCIONES MASIVAS
                <v-tooltip
                  bottom
                  v-if="
                    !puedeRealizarAccionMasiva && casosSeleccionados.length > 0
                  "
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon right small v-bind="attrs" v-on="on"
                      >mdi-information</v-icon
                    >
                  </template>
                  <span
                    >No se pueden combinar casos con estados diferentes</span
                  >
                </v-tooltip>
              </v-btn>
            </template>
            <!-- tabla donde se pintan los datos obtenidos del arreglo -->
            <template v-slot:[`item.semaforo`]="{ item }">
              <SemaforoTiempo
                :fecha-inicio="item.fecha_area"
                :dias="requerimientosInfo[item.cc_id_requerimiento]?.dias || 0"
                :horas="
                  requerimientosInfo[item.cc_id_requerimiento]?.horas || 0
                "
                :minutos="
                  requerimientosInfo[item.cc_id_requerimiento]?.minutos || 0
                "
                :id-caso="item.cc_id_caso"
                :tiempo-restante-backend="item.tiempoRestanteBackend"
                :tiempo-acumulado="item.tiempo_acumulado"
                :fecha-suspension="item.fecha_suspension"
                :estado-caso="item.estado_caso"
                :dias-festivos="diasFestivos"
                @caso-vencido="handleCasoVencido"
              />
            </template>
            <template v-slot:[`item.cc_prioridad_requerimiento`]="{ item }">
              <div v-if="item.cc_prioridad_requerimiento === '3'">
                <v-chip outlined class="ma-2" :color="item.color">
                  ALTA
                </v-chip>
              </div>
              <div v-if="item.cc_prioridad_requerimiento === '2'">
                <v-chip outlined class="ma-2" :color="item.color">
                  MEDIA
                </v-chip>
              </div>
              <div v-if="item.cc_prioridad_requerimiento === '1'">
                <v-chip outlined class="ma-2" :color="item.color">
                  BAJA
                </v-chip>
              </div>
            </template>
            <template v-slot:[`item.cc_id_asesor`]="{ item }">
              <v-icon color="primary" @click="handleAsesor(item.infoAsesor)">
                mdi-account-tie
              </v-icon>
              <v-icon color="purple" @click="verHistorial(item)" class="ml-1">
                mdi-timeline-clock
              </v-icon>
            </template>
            <!-- tabla donde se pintan los datos obtenidos del arreglo -->
            <template v-slot:[`item.action`]="{ item }">
              <!-- Botón de asignar solo para casos pendientes -->
              <v-icon
                v-if="item.nombre_especialista == 'SIN ASIGNAR'"
                color="green"
                class="mr-2"
                @click="asignarCaso(item)"
              >
                mdi-clipboard-check-outline
              </v-icon>

              <!-- Botón de ver conversación para todos los casos -->
              <v-icon color="blue" class="mr-2" @click="verConversacion(item)">
                mdi-eye
              </v-icon>

              <!-- Botón de cerrar caso para casos asignados al usuario actual -->
              <v-icon
                v-if="item.nombre_especialista == nombre"
                color="red"
                class="mr-2"
                @click="cerrarCaso(item)"
              >
                mdi-folder-remove-outline
              </v-icon>

              <!-- Botón de cambiar estado para casos asignados al usuario actual -->
              <v-icon
                v-if="item.nombre_especialista == nombre"
                color="green"
                class="mr-2"
                @click="cambiarEstado(item)"
              >
                mdi-cog-clockwise
              </v-icon>

              <!-- Botón de escalar solo para casos pendientes sin asignar -->
              <v-icon
                v-if="item.escalamiento == null && item.id_especialista == 0"
                color="red"
                class="mr-2"
                @click="escalar(item)"
              >
                mdi-elevator-up
              </v-icon>

              <!-- Botón de agregar observación para todos los casos -->
              <v-icon
                color="orange"
                class="mr-2"
                @click="abrirAgregarObservacion(item)"
              >
                mdi-comment-plus
              </v-icon>

              <!-- Botón de desasignar para casos asignados al usuario actual -->
              <!-- <v-icon
                    v-if="item.nombre_especialista != 'SIN ASIGNAR' && item.nombre_especialista == nombre"
                    color="blue"
                    class="mr-2"
                    @click="desasignarCaso(item)"
                    >
                    mdi-folder-clock-outline
                    </v-icon> -->
            </template>
            <template v-slot:no-data>
              <v-alert :value="true" color="#111c3d" icon="mdi-alert" outlined
                >No se encontro su busqueda</v-alert
              >
            </template>
          </v-data-table>
          <v-dialog
            v-model="dialogConfirmarAsignacionMasiva"
            max-width="500px"
            persistent
          >
            <v-card>
              <v-card-title class="nav">
                <span class="headline" style="color: white">
                  <v-icon color="white">mdi-clipboard-check-outline</v-icon>
                  Asignar caso
                </span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-card-text style="font-size: 18px; color: black">
                    ¿Está seguro que desea asignarse estos casos?
                  </v-card-text>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="#1D3C7F"
                  dark
                  @click="dialogConfirmarAsignacionMasiva = false"
                  >NO</v-btn
                >
                <v-btn color="#1D3C7F" dark @click="confirmarAsignacionMasiva"
                  >SI</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Modal para asignación masiva de líderes -->
          <v-dialog
            v-model="dialogAsignacionMasivaLider"
            max-width="500px"
            persistent
          >
            <v-card>
              <v-card-title class="nav">
                <span class="headline" style="color: white">
                  <v-icon color="white">mdi-account-multiple-plus</v-icon>
                  Asignar casos a especialista
                </span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-autocomplete
                    class="mt-4"
                    v-model="especialistaSeleccionadoMasivo"
                    :items="items"
                    item-text="nombre"
                    item-value="idUsuario"
                    filled
                    label="Seleccione el especialista"
                    :rules="[(v) => !!v || 'Debe seleccionar un especialista']"
                  ></v-autocomplete>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#1D3C7F" dark @click="closeAsignacionMasivaLider"
                  >CANCELAR</v-btn
                >
                <v-btn
                  color="#1D3C7F"
                  dark
                  @click="confirmarAsignacionMasivaLider"
                  :disabled="!especialistaSeleccionadoMasivo"
                  >ASIGNAR</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Modal de acciones masivas -->
          <v-dialog v-model="dialogAccionMasiva" max-width="600px" persistent>
            <v-card>
              <v-card-title class="nav">
                <span class="headline" style="color: white">
                  <v-icon color="white">mdi-playlist-edit</v-icon>
                  Acción masiva sobre casos seleccionados
                </span>
              </v-card-title>
              <v-card-text>
                <div class="acciones-masivas-list">
                  <v-btn
                    v-for="accion in accionesDisponiblesSegunEstado"
                    :key="accion.key"
                    :color="accion.color"
                    class="accion-masiva-opcion"
                    :class="{
                      'accion-masiva-opcion--active':
                        accionSeleccionada === accion.key,
                    }"
                    @click="seleccionarAccionMasiva(accion.key)"
                    large
                  >
                    <v-icon left>{{ accion.icon }}</v-icon>
                    {{ accion.label }}
                  </v-btn>
                  <div
                    v-if="accionesDisponiblesSegunEstado.length === 0"
                    class="text-center pa-4"
                  >
                    <v-alert type="warning" outlined>
                      No hay acciones masivas disponibles para los casos
                      seleccionados.
                      <br />
                      <small
                        >Selecciona casos con el mismo estado para ver las
                        acciones disponibles.</small
                      >
                    </v-alert>
                  </div>
                </div>
                <div v-if="accionSeleccionada">
                  <div
                    v-if="
                      accionSeleccionada === 'asignar' &&
                      mostrarConfirmacionAsignacion
                    "
                  >
                    <p style="font-size: 18px; color: black; margin-top: 24px">
                      ¿Está seguro que desea asignarse estos casos?
                    </p>
                  </div>
                  <div v-else-if="accionSeleccionada === 'desasignar'">
                    <p style="font-size: 18px; color: black; margin-top: 24px">
                      ¿Está seguro que desea desasignar estos casos?
                    </p>
                  </div>
                  <div v-else-if="accionSeleccionada === 'reasignar'">
                    <p style="font-size: 18px; color: black; margin-top: 24px">
                      ¿A qué especialista desea reasignar estos casos?
                    </p>
                    <v-select
                      v-model="especialistaSeleccionado"
                      :items="especialistasDisponibles"
                      item-text="nombre"
                      item-value="idUsuario"
                      label="Seleccionar especialista"
                      outlined
                      class="mt-4"
                      :loading="cargandoEspecialistas"
                      :disabled="cargandoEspecialistas"
                    ></v-select>
                    <v-text-field
                      v-model="observacionReasignacion"
                      label="Observación de reasignación"
                      outlined
                      class="mt-4"
                    ></v-text-field>
                  </div>
                  <div v-else-if="accionSeleccionada === 'cerrar'">
                    <p style="font-size: 18px; color: black; margin-top: 24px">
                      ¿Está seguro que desea cerrar estos casos?
                    </p>
                    <v-text-field
                      v-model="masivoObservaciones"
                      label="Observaciones"
                      outlined
                      class="mt-4"
                      :rules="observacionesRules"
                      required
                    />
                    <!-- INICIO componente del modal agregar varios archivos -->
                    <div
                      id="drop-area"
                      @dragover.prevent
                      @dragenter.prevent
                      @drop.prevent="handleDropMultiple"
                      @paste.prevent="handlePasteMultiple"
                      style="margin-top: 16px"
                    >
                      <div v-if="previewImages.length">
                        <div
                          v-for="(img, idx) in previewImages"
                          :key="idx"
                          style="margin-bottom: 8px"
                        >
                          <img
                            :src="img"
                            alt="Vista previa"
                            style="
                              max-width: 100px;
                              max-height: 100px;
                              display: block;
                              margin: 0 auto;
                            "
                          />
                        </div>
                      </div>
                      <div v-if="selectedFiles.length">
                        <div
                          v-for="(file, idx) in selectedFiles"
                          :key="idx"
                          style="margin-bottom: 8px"
                        >
                          <v-icon color="primary" v-if="!isImageFile(file)"
                            >mdi-file</v-icon
                          >
                          <span>{{ file.name }}</span>
                        </div>
                      </div>
                      <span
                        v-if="!previewImages.length && !selectedFiles.length"
                      >
                        Arrastra y suelta o copia y pega archivos aquí (Word,
                        Excel, PDF, imágenes)
                      </span>
                    </div>
                    <input
                      type="file"
                      ref="fileInput"
                      @change="handleFileChangeMultiple"
                      style="display: none"
                      multiple
                      accept=".jpg,.jpeg,.png,.gif,.webp,.svg,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.odt,.ods,.odp,.rtf,.zip,.rar"
                    />
                    <button
                      @click="openFileInput"
                      class="upload-button"
                      style="margin-top: 8px"
                    >
                      Seleccionar Archivos
                    </button>
                    <!-- FIN componente del modal agregar varios archivos -->
                  </div>
                  <div v-else-if="accionSeleccionada === 'suspender'">
                    <p style="font-size: 18px; color: black; margin-top: 24px">
                      ¿Por qué desea suspender estos casos?
                    </p>
                    <v-text-field
                      v-model="masivoMotivo"
                      label="Motivo"
                      outlined
                      class="mt-4"
                    />
                  </div>
                  <div v-else-if="accionSeleccionada === 'anular'">
                    <p style="font-size: 18px; color: black; margin-top: 24px">
                      ¿Por qué desea anular estos casos?
                    </p>
                    <v-text-field
                      v-model="masivoMotivo"
                      label="Motivo"
                      outlined
                      class="mt-4"
                    />
                  </div>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#1D3C7F" dark @click="cerrarModalAccionMasiva"
                  >CANCELAR</v-btn
                >
                <v-btn
                  color="#1D3C7F"
                  :disabled="
                    !accionSeleccionada ||
                    (accionSeleccionada === 'cerrar' &&
                      !isObservacionMasivaValida) ||
                    ((accionSeleccionada === 'suspender' ||
                      accionSeleccionada === 'anular') &&
                      !masivoMotivo) ||
                    (accionSeleccionada === 'reasignar' &&
                      !especialistaSeleccionado)
                  "
                  dark
                  @click="confirmarAccionMasiva"
                  >CONFIRMAR</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Modal de desasignación -->
          <v-dialog v-model="dialogDesasignar" max-width="500px" persistent>
            <v-card>
              <v-card-title class="nav">
                <span class="headline" style="color: white">
                  <v-icon color="white">mdi-folder-clock-outline</v-icon>
                  Deshacer asignación
                </span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-card-text style="font-size: 18px; color: black">
                    ¿Está seguro que desea desasignar este caso?
                  </v-card-text>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#1D3C7F" dark @click="closeDesasignar">No</v-btn>
                <v-btn color="#1D3C7F" dark @click="confirmarDesasignar"
                  >Si</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- alertas de las acciones que se hacen -->
          <v-snackbar
            v-model="snackbar"
            :bottom="y === 'bottom'"
            :left="x === 'left'"
            :multi-line="mode === 'multi-line'"
            :right="x === 'right'"
            :timeout="timeout"
            :top="y === 'top'"
            :vertical="mode === 'vertical'"
            color="#294697"
            style="color: white"
          >
            {{ text }}
            <v-btn color="#294697" depressed @click="snackbar = false"
              >Cerrar</v-btn
            >
          </v-snackbar>

          <!-- Modal para ver las evidencias del caso -->
          <v-dialog v-model="dialogEvidencias" max-width="900px">
            <v-card>
              <v-card-title class="nav">
                <span class="headline" style="color: white">
                  <v-icon color="white">mdi-image-multiple</v-icon>
                  Evidencias del caso #{{ idCasoActual }}
                </span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <div v-if="cargandoEvidencias" class="text-center my-5">
                    <v-progress-circular
                      indeterminate
                      color="#294697"
                    ></v-progress-circular>
                    <p>Cargando evidencias...</p>
                  </div>
                  <div v-else-if="!evidencias.length" class="text-center my-5">
                    <v-alert type="info" outlined>
                      No hay evidencias disponibles para este caso.
                    </v-alert>
                  </div>
                  <v-row v-else>
                    <v-col
                      v-for="(evidencia, index) in evidencias"
                      :key="index"
                      cols="12"
                      sm="6"
                      md="4"
                    >
                      <v-card outlined>
                        <template
                          v-if="isImageUrl(evidencia.cc_ruta_evidencia)"
                        >
                          <v-img
                            :src="evidencia.cc_ruta_evidencia"
                            aspect-ratio="1"
                            class="grey lighten-2"
                            @click="
                              verImagenCompleta(evidencia.cc_ruta_evidencia)
                            "
                            style="cursor: pointer"
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="#294697"
                                ></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </template>
                        <template v-else>
                          <v-card
                            class="d-flex flex-column align-center justify-center pa-3"
                            style="
                              cursor: pointer;
                              aspect-ratio: 1;
                              height: 100%;
                            "
                            @click="downloadFile(evidencia.cc_ruta_evidencia)"
                          >
                            <v-icon size="80" color="grey darken-1"
                              >mdi-file-document-outline</v-icon
                            >
                            <div
                              class="mt-2 text-caption grey--text text--darken-1 text-center"
                              style="word-break: break-all"
                            >
                              {{ getFileName(evidencia.cc_ruta_evidencia) }}
                            </div>
                          </v-card>
                        </template>
                        <v-card-text class="pa-2">
                          <small class="grey--text">{{
                            formatDate(evidencia.fecha_subida)
                          }}</small>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#1D3C7F" dark @click="closeEvidencias"
                  >CERRAR</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Modal para ver una imagen en pantalla completa -->
          <v-dialog v-model="dialogImagenCompleta" max-width="90vw" fullscreen>
            <v-card flat>
              <v-toolbar dark color="#1D3C7F" flat>
                <v-btn icon dark @click="descargarImagen">
                  <v-icon>mdi-download</v-icon>
                </v-btn>
                <v-toolbar-title>Evidencia</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="dialogImagenCompleta = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text
                class="pa-0 d-flex justify-center align-center"
                style="height: calc(100vh - 64px); background-color: #000"
              >
                <img
                  :src="imagenSeleccionada"
                  style="max-height: 95vh; max-width: 95vw; object-fit: contain"
                />
              </v-card-text>
            </v-card>
          </v-dialog>

          <!-- Modal para ver el historial de acciones del caso -->
          <CaseHistoryTimeline
            v-if="idCasoActual !== null"
            :caseId="idCasoActual"
            :visible.sync="dialogHistorial"
          />
          <v-dialog v-model="dialogAgregarObservacion" max-width="500px">
            <v-card>
              <v-card-title>Agregar Observación</v-card-title>
              <v-card-text>
                <v-textarea
                  class="pt-5"
                  v-model="nuevaObservacion"
                  label="Observación"
                  rows="2"
                ></v-textarea>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn text @click="dialogAgregarObservacion = false"
                  >Cancelar</v-btn
                >
                <v-btn color="primary" @click="guardarObservacion"
                  >Guardar</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <CaseHistoryTimeline
            v-if="idCasoActual !== null"
            :caseId="idCasoActual"
            :visible.sync="dialogHistorialObservaciones"
            :soloObservaciones="true"
          />
        </v-card>
      </v-flex>
    </v-layout>

    <!-- MODAL DEL ASESOR ------------------------------------ -->
    <v-dialog
      class="dialogAsesor"
      v-model="showDialogAsesor"
      persistent
      max-width="400"
    >
      <v-card class="mx-auto" max-width="400" outlined>
        <v-list-item three-line>
          <v-list-item-content>
            <div class="text-overline mb-4">INFO. ASESOR</div>
            <v-list-item-title class="text-h6 mb-2">
              {{ objAsesor.nombre }}
            </v-list-item-title>
            <v-list-item-subtitle class="mb-2 mt-2">
              <v-icon class="mr-2" size="19">mdi-card-account-details</v-icon>
              {{ objAsesor.cedula }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              <v-icon class="mr-2" size="20">mdi-phone</v-icon>
              {{ objAsesor.telefono }}
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-avatar size="80" color="blue" rounded="50">
            <v-icon size="60" color="white"> mdi-account-tie </v-icon>
          </v-list-item-avatar>
        </v-list-item>
        <v-card-actions>
          <v-btn
            color="primary"
            elevation="2"
            outlined
            raised
            class="ms-auto"
            @click="showDialogAsesor = false"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- /MODAL DEL ASESOR ------------------------------------ -->

    <v-dialog v-model="dialog1" max-width="500px" persistent>
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: white"
            ><v-icon color="white">mdi-clipboard-check-outline</v-icon>
            Asignar caso
          </span>
        </v-card-title>
        <!-- componente del modal para agregar y actualizar -->
        <v-card-text>
          <v-container grid-list-md>
            <v-card-text style="font-size: 18px; color: black">
              ¿Está seguro que desea asignarse este caso?
            </v-card-text>
          </v-container>
        </v-card-text>
        <!-- botones para cancelar y agregregar y validacion de campos vacios -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#1D3C7F" dark @click="close1">No</v-btn>
          <v-btn color="#1D3C7F" dark @click="save1(idCaso)">Si</v-btn>
        </v-card-actions>
        <!-- <pre>{{editedItem}}</pre>  -->
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog4" max-width="500px" persistent>
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: white"
            ><v-icon color="white">mdi-clipboard-check-outline</v-icon>
            Asignar caso
          </span>
        </v-card-title>
        <!-- componente del modal para agregar y actualizar -->
        <v-card-text>
          <v-container>
            <v-autocomplete
              class="mt-4"
              v-model="value"
              :items="items"
              item-text="nombre"
              item-value="idUsuario"
              filled
              label="Seleccione el usuario"
            ></v-autocomplete>
          </v-container>
        </v-card-text>
        <!-- botones para cancelar y agregregar y validacion de campos vacios -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#1D3C7F" dark @click="close4()">No</v-btn>
          <v-btn color="#1D3C7F" dark @click="save4(idCaso)" :disabled="!value"
            >Si</v-btn
          >
        </v-card-actions>
        <!-- <pre>{{editedItem}}</pre>  -->
      </v-card>
    </v-dialog>
    <!-- Dialog que permite visualizar la conversacion -->
    <v-dialog v-model="dialog2" max-width="500px" persistent>
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: white"
            ><v-icon color="white">mdi-message-bulleted</v-icon>
            Conversación</span
          >
        </v-card-title>
        <!-- componente del modal para agregar y actualizar -->
        <v-card-text>
          <div v-for="(chat, index) in chatItem" :key="index">
            <v-card class="mt-3 mx-auto" width="550">
              <v-card-subtitle v-if="chat.user == 'NOVA'" class="pb-0">
                <p class="indigo--text text--darken-3">
                  <v-icon color="indigo darken-4" class="ml-5 mr-1"
                    >mdi-robot</v-icon
                  >{{ chat.user }}
                </p>
              </v-card-subtitle>
              <v-card-subtitle v-else class="d-flex justify-end">
                <p class="deep-purple--text text--accent-3">
                  <v-icon color="deep-purple accent-4" class="ml-5 mr-1"
                    >mdi-face</v-icon
                  >{{ chat.user }}
                </p>
              </v-card-subtitle>
              <v-card-text v-if="chat.user == 'NOVA'" class="">
                <p class="grey--text text--darken-1 text-left chat-message">
                  {{ chat.message }}
                </p>
              </v-card-text>
              <v-card-text v-else class="d-flex justify-end">
                <p class="grey--text text--darken-1 text-right chat-message">
                  {{ chat.message }}
                </p>
              </v-card-text>
            </v-card>
          </div>
          <v-divider class="mt-5"></v-divider>
        </v-card-text>
        <!-- botones para cancelar y agregregar y validacion de campos vacios -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#1D3C7F"
            dark
            @click="verEvidencias(idCasoActual)"
            class="mr-2"
          >
            <v-icon left>mdi-image-multiple</v-icon>
            VER EVIDENCIAS
          </v-btn>
          <v-btn color="#1D3C7F" dark @click="close2">CERRAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog5" max-width="800px" persistent>
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: white"
            ><v-icon color="white">mdi-elevator-up</v-icon> Escalar</span
          >
        </v-card-title>
        <!-- componente del modal para agregar y actualizar -->
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 sm6 md5 class="mr-14 mt-5">
              <v-autocomplete
                color="#294697"
                persistent-hint
                v-model="editedItem.idArea"
                label="Area"
                :items="areas"
                item-value="idArea"
                item-text="area"
                @change="llamarRequerimientos(editedItem.idArea)"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 sm6 md6 class="mt-5">
              <v-autocomplete
                color="#294697"
                persistent-hint
                v-model="editedItem.requerimientos"
                label="Requerimiento"
                :items="requerimientos"
                item-value="cc_id_requerimientos"
                :item-text="
                  (item) =>
                    item.cc_nombre_requerimiento_con_empresa ||
                    item.cc_nombre_requerimiento
                "
                @change="actualizarAreaDesdeRequerimiento"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{
                      item.cc_nombre_requerimiento
                    }}</v-list-item-title>
                    <v-list-item-subtitle v-if="item.nombreEmpresa">
                      <strong>{{ item.nombreEmpresa }}</strong>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
                <template v-slot:selection="{ item }">
                  <span
                    >{{ item.cc_nombre_requerimiento }}
                    <strong v-if="item.nombreEmpresa"
                      >({{ item.nombreEmpresa }})</strong
                    ></span
                  >
                </template>
              </v-autocomplete>
            </v-flex>
          </v-layout>
        </v-card-text>
        <!-- botones para cancelar y agregregar y validacion de campos vacios -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#1D3C7F" dark @click="close5">CERRAR</v-btn>
          <v-btn
            color="#1D3C7F"
            dark
            @click="save5(idCaso)"
            :disabled="!editedItem.idArea || !editedItem.requerimientos"
            >ESCALAR</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog3" max-width="500px" persistent>
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: white"
            ><v-icon color="white">mdi-folder-remove-outline</v-icon> Cerrar
            caso</span
          >
        </v-card-title>
        <!-- componente del modal para agregar y actualizar -->
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-text-field
                  v-model="editedItem3.Observaciones"
                  label="Observaciones"
                  :rules="observacionesRules"
                  required
                ></v-text-field>
                <!-- INICIO componente del modal agregar imagenes o archivos//jempoder -->
                <div
                  id="drop-area"
                  @dragover.prevent
                  @dragenter.prevent
                  @drop.prevent="handleDropMultiple"
                  @paste.prevent="handlePasteMultiple"
                >
                  <div v-if="previewImages.length">
                    <div
                      v-for="(img, idx) in previewImages"
                      :key="idx"
                      style="margin-bottom: 8px"
                    >
                      <img
                        :src="img"
                        alt="Vista previa"
                        style="
                          max-width: 100px;
                          max-height: 100px;
                          display: block;
                          margin: 0 auto;
                        "
                      />
                    </div>
                  </div>
                  <div v-if="selectedFiles.length">
                    <div
                      v-for="(file, idx) in selectedFiles"
                      :key="idx"
                      style="margin-bottom: 8px"
                    >
                      <v-icon color="primary" v-if="!isImageFile(file)"
                        >mdi-file</v-icon
                      >
                      <span>{{ file.name }}</span>
                    </div>
                  </div>
                  <span v-if="!previewImages.length && !selectedFiles.length">
                    Arrastra y suelta o copia y pega archivos aquí (Word, Excel,
                    PDF, imágenes) Máximo 5 archivos
                  </span>
                </div>
                <input
                  type="file"
                  ref="fileInput"
                  @change="handleFileChangeMultiple"
                  style="display: none"
                  multiple
                  accept=".jpg,.jpeg,.png,.gif,.webp,.svg,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.odt,.ods,.odp,.rtf,.zip,.rar"
                />
                <button @click="openFileInput" class="upload-button">
                  Seleccionar Archivos
                </button>
                <!-- FIN componente del modal agregar imagenes o archivos//jempoder -->
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <!-- botones para cancelar y agregregar y validacion de campos vacios -->
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="#1D3C7F" dark @click="close3">CANCELAR</v-btn>
          <v-btn
            color="#1D3C7F"
            dark
            @click="save3(idCaso)"
            :disabled="!isObservacionValida"
            >CERRAR CASO</v-btn
          >
        </v-card-actions>
        <!-- <pre>{{editedItem}}</pre>  -->
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog6" max-width="600px" persistent>
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: whitesmoke">
            <v-icon color="white">mdi-pencil</v-icon>
            Cambiar estado
          </span>
        </v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 class="mt-5">
              <v-select
                color="#294697"
                v-model="editedItem.estado"
                :items="['SUSPENDIDO', 'ANULADO', 'REASIGNAR', 'DESASIGNAR']"
                label="Selecciona cambio de estado"
                persistent-hint
                outlined
              ></v-select>
              <v-text-field
                v-model="editedItem.observacion"
                label="Observaciones"
                outlined
                class="mt-4"
              ></v-text-field>

              <div v-if="editedItem.estado === 'REASIGNAR'" class="mt-4">
                <v-select
                  v-model="especialistaSeleccionado"
                  :items="especialistasDisponibles"
                  item-text="nombre"
                  item-value="idUsuario"
                  label="Seleccionar especialista"
                  outlined
                  :loading="cargandoEspecialistas"
                  :disabled="cargandoEspecialistas"
                ></v-select>
                <v-text-field
                  v-model="observacionReasignacion"
                  label="Observación de reasignación"
                  outlined
                  class="mt-4"
                ></v-text-field>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#1D3C7F" dark @click="close6">CANCELAR</v-btn>
          <v-btn
            color="#1D3C7F"
            dark
            @click="guardarEstado"
            :disabled="
              !editedItem.estado ||
              (editedItem.estado === 'REASIGNAR' && !especialistaSeleccionado)
            "
            >GUARDAR</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal para desasignación individual -->
    <v-dialog v-model="dialogDesasignar" max-width="500px" persistent>
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: white">
            <v-icon color="white">mdi-folder-clock-outline</v-icon>
            Deshacer asignación
          </span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-card-text style="font-size: 18px; color: black">
              ¿Está seguro que desea desasignar este caso?
            </v-card-text>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#1D3C7F" dark @click="closeDesasignar">No</v-btn>
          <v-btn color="#1D3C7F" dark @click="confirmarDesasignar">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import swal from "sweetalert";
import axios from "axios";
import env from "../../env";
import SemaforoTiempo from "./SemaforoTiempo.vue";
import CaseHistoryTimeline from "./CaseHistoryTimeline.vue";

export default {
  components: {
    SemaforoTiempo,
    CaseHistoryTimeline,
  },
  props: {
    // Cuando se define, sobreescribe el área del usuario para el filtrado
    forzarArea: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      // Propiedades para el filtro
      selectedFilter: "tickets",
      showFilterMenu: false,
      filterOptions: [
        { text: "TICKETS", value: "tickets" },
        { text: "PENDIENTES", value: "pendientes" },
        { text: "ASIGNADOS", value: "asignados" },
        { text: "SUSPENDIDOS", value: "suspendidos" },
        { text: "CERRADOS", value: "cerrados" },
      ],

      // 🟢 NUEVO: Filtro específico para Gestión Humana
      filtroGestionHumana: "todos",
      opcionesGestionHumana: [
        { text: "Todos", value: "todos" },
        { text: "Nómina", value: "nomina" },
        { text: "Bienestar", value: "bienestar" },
        { text: "SST", value: "sst" },
        { text: "Capacitación", value: "capacitacion" },
      ],

      /////////////////////////////////////////////JEMPODER
      previewImage: null,
      filesToUpload: null,
      loadingObtenerCasos: false,
      intervalId: null, // 🆕 Para guardar el setInterval y poder limpiarlo
      /////////////////////////////////////////////JEMPODER
      objAsesor: {
        nombre: "",
        cedula: "",
        telefono: "",
        correo: "",
      },
      showDialogAsesor: false,
      show: false,
      nombre: localStorage.getItem("nombre"),
      idCargo: localStorage.getItem("idCargo"),
      snackbar: false,
      y: "top",
      x: null,
      mode: "",
      timeout: 6000,
      text: "",
      search: "",
      casos: [],
      // 🆕 Filtro por empresa
      casosOriginales: [],
      filtroEmpresa: "todos",
      opcionesEmpresa: [
        { text: "Todos", value: "todos" },
        { text: "Apostar", value: "apostar" },
        { text: "Facilisimo", value: "facilisimo" },
      ],
      // 🆕 idArea del usuario para filtrar casos por área
      idAreaUsuario: null,
      // 🆕 idEmpresa del usuario para filtrar casos por empresa
      idEmpresaUsuario: null,
      // 🆕 idEmpresa del caso actual para filtrar áreas al escalar
      idEmpresaCaso: null,
      items: [],
      value: null,
      idCaso: null,
      dialog1: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      dialog5: false,
      dialog6: false,
      dialogDesasignar: false,
      fechaArea: "",
      idCaso: "",
      casoPendienteObj: {},
      headers: [
        {
          text: "ESTADO",
          value: "semaforo",
          align: "center",
          class: "column",
          sortable: false,
          width: "110px",
        },
        {
          text: "ACCIONES",
          value: "action",
          align: "center",
          class: "column",
          sortable: false,
        },
        {
          text: "ID",
          value: "cc_id_caso",
          align: "center",
          class: "column",
        },
        {
          text: "AREA",
          value: "cc_nombre_area",
          align: "center",
          class: "column",
        },
        {
          text: "IP",
          value: "ip",
          align: "center",
          class: "column",
        },
        {
          text: "NOMBRE PUNTO",
          value: "nombre_punto",
          align: "center",
          class: "column",
        },
        {
          text: "EMPRESA",
          value: "nombreEmpresa",
          align: "center",
          class: "column",
        },
        {
          text: "MUNICIPIO",
          value: "municipio",
          align: "center",
          class: "column",
        },
        {
          text: "PRIORIDAD",
          value: "cc_prioridad_requerimiento",
          align: "center",
          class: "column",
        },
        {
          text: "FECHA/HORA APERTURA",
          value: "fecha_inicio",
          align: "center",
          class: "column",
        },
        {
          text: "REQUERIMIENTO",
          value: "cc_nombre_requerimiento",
          align: "center",
          class: "column",
        },
        {
          text: "ESPECIALISTA ASIGNADO",
          value: "nombre_especialista",
          align: "center",
          class: "column",
        },
        {
          text: "INFO. ASESOR",
          value: "cc_id_asesor",
          align: "center",
          class: "column",
        },
      ],
      headers2: [
        {
          text: "USUARIO",
          align: "left",
          value: "user",
          align: "center",
          class: "column",
        },
        {
          text: "MESSAGE",
          align: "left",
          value: "message",
          align: "center",
          class: "column",
        },
      ],
      requerimientos: [],
      areas: [],
      defaultItem: [],
      editedIndex: -1,
      editedItem: {
        Observaciones: "",
        requerimientos: "",
        idArea: "",
        area: "",
      },
      defaultItem3: [],
      editedItem3: {
        Observaciones: "",
      },
      chatItem: [],
      requerimientosInfo: {},
      dialogEvidencias: false,
      dialogImagenCompleta: false,
      evidencias: [],
      cargandoEvidencias: false,
      imagenSeleccionada: "",
      idCasoActual: null,
      dialogHistorial: false,
      diasFestivos: [],
      casosSeleccionados: [],
      dialogConfirmarAsignacionMasiva: false,
      dialogAsignacionMasivaLider: false,
      especialistaSeleccionadoMasivo: null,
      esLider: false,
      mostrarConfirmacionAsignacion: false,
      dialogAgregarObservacion: false,
      nuevaObservacion: "",
      casoSeleccionado: null,
      dialogHistorialObservaciones: false,
      dialogAccionMasiva: false,
      accionesMasivas: [
        {
          key: "asignar",
          label: "Asignar seleccionados",
          icon: "mdi-account-multiple-plus",
          color: "orange lighten-2",
          visible: ["tickets", "pendientes"],
        },
        {
          key: "reasignar",
          label: "Reasignar",
          icon: "mdi-account-switch",
          color: "blue lighten-2",
          visible: ["asignados", "tickets"],
        },
        {
          key: "cerrar",
          label: "Cerrar caso",
          icon: "mdi-folder-remove-outline",
          color: "red lighten-2",
          visible: ["asignados", "tickets"],
        },
        {
          key: "suspender",
          label: "Suspender caso",
          icon: "mdi-folder-clock-outline",
          color: "green lighten-2",
          visible: ["asignados", "tickets"],
        },
        {
          key: "anular",
          label: "Anular caso",
          icon: "mdi-cancel",
          color: "grey lighten-1",
          visible: ["asignados", "tickets", "suspendidos"],
        },
        {
          key: "desasignar",
          label: "Desasignar caso",
          icon: "mdi-account-remove-outline",
          color: "blue lighten-2",
          visible: ["asignados", "tickets"],
        },
      ],
      accionSeleccionada: null,
      masivoObservaciones: "",
      masivoMotivo: "",
      previewImages: [],
      selectedFiles: [],
      dialogDesasignar: false,
      // Propiedades para reasignación
      especialistasDisponibles: [],
      especialistaSeleccionado: null,
      observacionReasignacion: "",
      cargandoEspecialistas: false,
      // Propiedades para observaciones
      editedItem3: {
        Observaciones: "",
      },
      observacionesRules: [
        (v) => !!v || "El campo Observaciones es obligatorio",
        (v) => (v && !v.startsWith(" ")) || "No puede iniciar con un espacio",
        (v) =>
          (v && v.trim().length >= 4) || "Debe contener mínimo 4 caracteres",
      ],
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },

    // Watcher para casos seleccionados
    casosSeleccionados: {
      handler(nuevosCasosSeleccionados) {
        if (nuevosCasosSeleccionados.length > 0) {
          const estadoSeleccionado = this.verificarEstadosSeleccionados();
          if (estadoSeleccionado === "mixto") {
            // Si hay estados mixtos, mostrar mensaje y limpiar selección
            this.text =
              "⚠️ No se pueden combinar casos con estados diferentes. Selecciona casos con el mismo estado.";
            this.snackbar = true;
            this.casosSeleccionados = [];
          }
        }
      },
      deep: true,
    },
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Permisos Aplicación"
        : "Editar Permisos";
    },
    // 🆕 Determinar si mostrar el filtro por empresa (solo para Mesa de Servicios y Sistemas)
    mostrarFiltroEmpresa() {
      // 🆕 Mostrar filtro para usuarios de Mesa de Servicios (área 1) y Sistemas (área 2)
      // Basado en idArea en lugar de idCargo para asegurar que todos los usuarios de estas áreas lo vean
      return this.idAreaUsuario === 1 || this.idAreaUsuario === 2;
    },
        
    casosVisualizar() {
      let casos = this.casosFiltrados;
      
      // Aplicar filtro de Gestión Humana SOLO si es área 3 y no está en "todos" (pero el select ya controla eso)
      if (this.idAreaUsuario === 3 && this.filtroGestionHumana !== "todos") {
        casos = casos.filter(caso => {
          // Obtener idEmpresa del caso
          let idEmpresaCaso = caso.idEmpresa;
          if (!idEmpresaCaso && caso.nombreEmpresa) {
            idEmpresaCaso = caso.nombreEmpresa.toUpperCase().includes("FACILISIMO") ? 1 : 2;
          }
          
          // Si el caso es de Apostar (idEmpresa === 2), lo mostramos sin filtrar
          if (idEmpresaCaso === 2) {
            return true;
          }
          
          // Si es de Facilisimo, aplicamos el filtro
          const nombreReq = caso.cc_nombre_requerimiento || "";
          
          switch (this.filtroGestionHumana) {
            case "nomina":
              return nombreReq.toUpperCase().includes("NOMINA") ||
                     nombreReq.toUpperCase().includes("DESPRENDIBLES DE NOMINA") ||
                     nombreReq.toUpperCase().includes("CERTIFICADO LABORAL") || 
                     nombreReq.toUpperCase().includes("CAMBIO DE EPS O FONDO DE PENSION");
            case "bienestar":
              return nombreReq.toUpperCase().includes("BIENESTAR") || 
                     nombreReq.toUpperCase().includes("PROCESOS DISCIPLINARIOS") || 
                     nombreReq.toUpperCase().includes("ACTIVIDADES BIENESTAR SOCIAL") || 
                     nombreReq.toUpperCase().includes("ACTIVIDADES NIÑOS");
            case "sst":
              return nombreReq.toUpperCase().includes("SST") || 
                     nombreReq.toUpperCase().includes("ACCIDENTE DE TRABAJO") || 
                     nombreReq.toUpperCase().includes("INSPECCION DE PUESTO DE TRABAJO") || 
                     nombreReq.toUpperCase().includes("SOLICITUD DE BOTIQUIN") || 
                     nombreReq.toUpperCase().includes("SOLICITUD DE CITA CON PSICOLOGO") || 
                     nombreReq.toUpperCase().includes("SOLICITUD DE CITA MEDICA") || 
                     nombreReq.toUpperCase().includes("SOLICITUD DE COMITE CONVIVENCIA LABORAL");
            case "capacitacion":
              return nombreReq.toUpperCase().includes("CAPACITACION") ||
                      nombreReq.toUpperCase().includes("SOLICITUD DE CAPACITACIONES") || 
                      nombreReq.toUpperCase().includes("SOLICITUD REINDUCCION") || 
                      nombreReq.toUpperCase().includes("CREACION DE USUARIOS UNIVERSIDAD CORPORATIVA") || 
                      nombreReq.toUpperCase().includes("ACTIVACION DE USUARIO TREBOL DEL SABER") || 
                      nombreReq.toUpperCase().includes("SOLICITUD DE CARNET") || 
                      nombreReq.toUpperCase().includes("SOLICITUD DE CHALECO") || 
                      nombreReq.toUpperCase().includes("POSTULACION VACANTE");
            default:
              return true;
          }
        });
      }
      
      return casos;
    }, 
    // 🆕 Casos filtrados por empresa Y por área
    casosFiltrados() {
      let casos = this.casos;

      // 🆕 VALIDACIÓN ESPECIAL: Para cargos 15 y 16 (LOGISTICA-MANTENIMIENTO), no filtrar por idAreaUsuario
      // Estos usuarios deben ver casos de áreas 11 y 12 de Apostar
      const esCargoLogisticaMantenimiento =
        this.idCargo == "15" || this.idCargo == "16";

      // 🆕 FILTRAR POR ÁREA PRIMERO (más importante que el filtro de empresa)
      // Si el usuario tiene idArea definido, filtrar estrictamente por área
      // EXCEPTO para cargos 15 y 16 que ven áreas 11 y 12
      // 🆕 Si se fuerza un área específica (desde TicketsDuales), filtrar por ella
      if (this.forzarArea !== null && this.forzarArea !== undefined) {
        casos = casos.filter((caso) => {
          const idAreaCaso = caso.cc_id_area_requerimiento
            ? parseInt(caso.cc_id_area_requerimiento)
            : null;
          return idAreaCaso === this.forzarArea;
        });
      } else if (
        this.idAreaUsuario !== null &&
        this.idAreaUsuario !== undefined &&
        !esCargoLogisticaMantenimiento
      ) {
        casos = casos.filter((caso) => {
          const idAreaCaso = caso.cc_id_area_requerimiento
            ? parseInt(caso.cc_id_area_requerimiento)
            : null;

          // Si el usuario es de Mesa de Servicios (área 1), SOLO casos de área 1
          if (this.idAreaUsuario === 1) {
            return idAreaCaso === 1;
          }
          // Si el usuario es de Sistemas (área 2), SOLO casos de área 2
          if (this.idAreaUsuario === 2) {
            return idAreaCaso === 2;
          }
          // Para otras áreas, permitir casos de su área
          return idAreaCaso === this.idAreaUsuario;
        });
      }

      // 🆕 Para cargos 15 y 16, filtrar solo casos de áreas 11 y 12 de su empresa (Facilisimo o Apostar)
      if (esCargoLogisticaMantenimiento) {
        casos = casos.filter((caso) => {
          const idAreaCaso = caso.cc_id_area_requerimiento
            ? parseInt(caso.cc_id_area_requerimiento)
            : null;
          const idEmpresa = caso.idEmpresa ? parseInt(caso.idEmpresa) : null;
          const idEmpresaUsuario = this.idEmpresaUsuario
            ? parseInt(this.idEmpresaUsuario)
            : null;

          // Solo mostrar casos de áreas 11 o 12 de la misma empresa del usuario
          // Si idEmpresaUsuario es null, no aplicar este filtro (mostrar todos los casos de áreas 11 y 12)
          if (idEmpresaUsuario === null) {
            return idAreaCaso === 11 || idAreaCaso === 12;
          }
          return (
            (idAreaCaso === 11 || idAreaCaso === 12) &&
            idEmpresa === idEmpresaUsuario
          );
        });
      }

      // Luego aplicar el filtro por empresa (si está activo)
      if (this.mostrarFiltroEmpresa && this.filtroEmpresa !== "todos") {
        casos = casos.filter((caso) => {
          const idEmpresa = caso.idEmpresa ? parseInt(caso.idEmpresa) : null;
          const nombreEmpresa = caso.nombreEmpresa
            ? caso.nombreEmpresa.toLowerCase()
            : "";

          if (this.filtroEmpresa === "apostar") {
            return idEmpresa === 2 || nombreEmpresa.includes("apostar");
          } else if (this.filtroEmpresa === "facilisimo") {
            return idEmpresa === 1 || nombreEmpresa.includes("facilisimo");
          }

          return true;
        });
      }

      return casos;
    },
    // Computed property para filtrar acciones masivas según el filtro seleccionado
    accionesMasivasFiltradas() {
      const accionesFiltradas = this.accionesMasivas.filter((accion) =>
        accion.visible.includes(this.selectedFilter),
      );

      return accionesFiltradas;
    },

    // Computed property para determinar si se puede realizar acción masiva
    puedeRealizarAccionMasiva() {
      if (this.casosSeleccionados.length < 2) return false;

      const estadoSeleccionado = this.verificarEstadosSeleccionados();
      return estadoSeleccionado && estadoSeleccionado !== "mixto";
    },

    // Computed property para obtener las acciones disponibles según el estado de los casos seleccionados
    accionesDisponiblesSegunEstado() {
      const accionesDisponibles = this.getAccionesDisponibles();
      return this.accionesMasivas.filter((accion) =>
        accionesDisponibles.includes(accion.key),
      );
    },

    isObservacionValida() {
      const obs = this.editedItem3.Observaciones;
      return obs && !obs.startsWith(" ") && obs.trim().length >= 4;
    },
    isObservacionMasivaValida() {
      const obs = this.masivoObservaciones;
      return obs && !obs.startsWith(" ") && obs.trim().length >= 4;
    },
  },

  async mounted() {
    await this.cargarDiasFestivos();
    await this.cargarEspecialistas();
    await this.obtenerAreas();
    await this.obtenerIdAreaUsuario(); // 🆕 Obtener el idArea del usuario
    await this.obtenerIdEmpresaUsuario(); // 🆕 Obtener el idEmpresa del usuario
    this.obtenerTodo();
    this.obtenerCasos();

    // 🆕 Guardar el intervalo para poder limpiarlo después
    this.intervalId = setInterval(() => {
      this.obtenerCasos();
    }, 60000); // cada 60 segundos
  },

  // 🆕 Limpiar el intervalo cuando el componente se destruye
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  },

  methods: {
    // 🟢 NUEVO: Aplicar filtro de Gestión Humana
    aplicarFiltroGestionHumana() {
      // Solo forzar actualización de la vista
      this.$forceUpdate();
    },

    // Método para cambiar de vista
    changeFilter() {
      // Actualizar los datos según el nuevo filtro
      this.obtenerCasos();
      // Emitir evento para que el componente padre maneje la navegación
      this.$emit("change-view", this.selectedFilter);
    },

    // Método para seleccionar opción del filtro en móvil
    selectFilterOption(value) {
      this.selectedFilter = value;
      this.showFilterMenu = false;
      // Actualizar los datos según el nuevo filtro
      this.obtenerCasos();
      this.$emit("change-view", value);
    },

    // 🆕 Método para aplicar filtro por empresa
    aplicarFiltroEmpresa() {
      // El filtrado se hace automáticamente en el computed casosFiltrados
      // Solo necesitamos forzar la actualización de la vista
      this.$forceUpdate();
    },

    //Inicio metodos para ingresar imagenes jempoder//////////////ed
    handleDrop(event) {
      event.preventDefault();

      if (event.dataTransfer.files.length > 0) {
        this.showPreview(event.dataTransfer.files[0]);
        this.filesToUpload = event.dataTransfer.files;
      }
    },
    handlePaste(event) {
      event.preventDefault();

      const items = (event.clipboardData || event.originalEvent.clipboardData)
        .items;

      for (const item of items) {
        if (item.kind === "file") {
          const file = item.getAsFile();
          this.showPreview(file);
          this.filesToUpload = [file];
        }
      }
    },
    handleFileChange() {
      const files = this.$refs.fileInput.files;
      if (files.length > 0) {
        this.showPreview(files[0]);
        this.filesToUpload = files;
      }
    },
    openFileInput() {
      this.$refs.fileInput.click();
    },
    showPreview(file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        this.previewImage = event.target.result;
      };
      reader.readAsDataURL(file);
    },
    uploadFiles(idCaso, uploadFiles) {
      if (this.filesToUpload) {
        const formData = new FormData();
        formData.append("file", this.filesToUpload[0]);

        formData.append("cc_id_caso", this.idCaso);

        axios
          .post(`${env.endpointEvidenciasCaso}`, formData)
          .then((response) => {
            // console.log(response.data);
            this.filesToUpload = null;
            this.previewImage = null;
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    //Fin Metodos para ingresar imagenes/////////////////////ed

    isImageUrl(url) {
      if (!url) return false;
      return /\.(jpeg|jpg|gif|png|webp|svg)$/i.test(url);
    },

    getFileName(url) {
      if (!url) return "Archivo";
      try {
        const fullPath = new URL(url).pathname;
        return fullPath.substring(fullPath.lastIndexOf("/") + 1);
      } catch (e) {
        // Fallback for relative paths or simple filenames
        const parts = url.split("/");
        return parts[parts.length - 1] || "Archivo";
      }
    },

    downloadFile(url) {
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", this.getFileName(url));
      // link.setAttribute('target', '_blank'); // Opens in new tab, useful for some file types or if download attribute is not honored
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    handleAsesor(asesor) {
      this.objAsesor = {
        nombre: asesor.nombre,
        telefono: asesor.celular,
        correo: asesor.correo,
        cedula: asesor.cedula,
      };
      // console.log(this.objAsesor);
      this.showDialogAsesor = true;
    },
    obtenerTodo() {
      const idUsuario = localStorage.getItem("id");
      axios
        .get(
          `${env.endpoint}callcenter/requerimientostodos?idUsuario=${idUsuario}`,
        )
        .then((res) => (this.todosRequerimientos = res.data));
    },
    // Método para obtener todos los incidentes con filtrado dinámico por área
    async obtenerCasos() {
      // 🆕 Prevenir llamadas simultáneas
      if (this.loadingObtenerCasos) {
        return; // Si ya está cargando, no hacer nada
      }
      this.loadingObtenerCasos = true;

      // 🆕 Timeout de seguridad para evitar bloqueos indefinidos
      const timeoutId = setTimeout(() => {
        if (this.loadingObtenerCasos) {
          console.warn(
            "obtenerCasos() tardó más de 30 segundos, forzando restablecimiento",
          );
          this.loadingObtenerCasos = false;
        }
      }, 30000); // 30 segundos máximo

      try {
        // Primero obtenemos los datos de requerimientos para tener los tiempos máximos
        const idUsuario = localStorage.getItem("id");
        const resReq = await axios.get(
          `${env.endpoint}callcenter/requerimientostodos?idUsuario=${idUsuario}`,
        );
        this.requerimientosInfo = {};
        resReq.data.forEach((req) => {
          this.requerimientosInfo[req.cc_id_requerimientos] = req;
        });

        // Obtener el área específica del usuario dinámicamente
        const areaUsuario = await this.obtenerAreaUsuario();
        if (!areaUsuario) {
          console.error("No se pudo obtener el área del usuario");
          this.casos = [];
        } else {
          // Obtener casos según el filtro seleccionado
          let casos = [];

          switch (this.selectedFilter) {
            case "tickets":
              casos = await this.obtenerCasosTickets(areaUsuario);
              break;
            case "pendientes":
              casos = await this.obtenerCasosPendientes();
              break;
            case "asignados":
              casos = await this.obtenerCasosAsignados(areaUsuario);
              break;
            case "suspendidos":
              casos = await this.obtenerCasosSuspendidos();
              break;
            case "cerrados":
              casos = await this.obtenerCasosCerrados(areaUsuario);
              break;
            default:
              casos = await this.obtenerCasosPendientes();
          }

          // Procesar todos los casos obtenidos
          this.procesarCasos(casos);
        }
      } catch (error) {
        console.error("Error en obtenerCasos:", error);
        this.casos = [];
      } finally {
        clearTimeout(timeoutId); // 🆕 Limpiar el timeout
        this.loadingObtenerCasos = false;
      }
    },

    // Método para obtener el área específica del usuario dinámicamente
    async obtenerAreaUsuario() {
      try {
        const idCargo = localStorage.getItem("idCargo");
        const resCargos = await axios.get(`${env.endpoint}user/cargos`);
        const cargoUsuario = resCargos.data.find(
          (cargo) => cargo.idCargo == idCargo,
        );

        if (cargoUsuario && cargoUsuario.cc_nombre_area) {
          return cargoUsuario.cc_nombre_area;
        } else {
          console.error(
            "No se encontró información del área para el cargo:",
            idCargo,
          );
          return null;
        }
      } catch (error) {
        console.error("Error obteniendo área del usuario:", error);
        return null;
      }
    },

    // Método para obtener casos de tickets (pendientes + asignados del usuario y colegas)
    async obtenerCasosTickets(areaUsuario) {
      try {
        let casos = [];

        // Obtener casos pendientes del usuario
        const idCargo = localStorage.getItem("idCargo");
        let endpointPendientes;
        if (
          idCargo == "3" ||
          idCargo == "4" ||
          idCargo == "15" ||
          idCargo == "16" ||
          idCargo == "17" ||
          idCargo == "20" 
        ) {
          endpointPendientes = `${
            env.endpoint
          }callcenter/incidentes_areas_especiales?idUsuario=${localStorage.getItem(
            "id",
          )}`;
        } else {
          endpointPendientes = `${
            env.endpoint
          }callcenter/incidentespendientes?idUsuario=${localStorage.getItem(
            "id",
          )}`;
        }
        const resPendientes = await axios.get(endpointPendientes);
        casos = [...casos, ...resPendientes.data];

        // Obtener casos asignados del usuario
        const resAsignadosUsuario = await axios.get(
          `${
            env.endpoint
          }callcenter/incidentesasignados?id=${localStorage.getItem("id")}`,
        );
        casos = [...casos, ...resAsignadosUsuario.data];

        // Obtener casos de colegas con el mismo cargo
        const casosColegas = await this.obtenerCasosDeColegas(areaUsuario);
        casos = [...casos, ...casosColegas];

        // 🆕 Eliminar duplicados por cc_id_caso
        const casosUnicos = this.eliminarDuplicadosPorId(casos);

        return casosUnicos;
      } catch (error) {
        console.error("Error obteniendo casos de tickets:", error);
        return [];
      }
    },

    // Método para obtener casos pendientes
    async obtenerCasosPendientes() {
      try {
        const idCargo = localStorage.getItem("idCargo");
        let endpointPendientes;
        if (
          idCargo == "3" ||
          idCargo == "4" ||
          idCargo == "15" ||
          idCargo == "16" ||
          idCargo == "17" ||
          idCargo == "20" 
        ) {
          endpointPendientes = `${
            env.endpoint
          }callcenter/incidentes_areas_especiales?idUsuario=${localStorage.getItem(
            "id",
          )}`;
        } else {
          endpointPendientes = `${
            env.endpoint
          }callcenter/incidentespendientes?idUsuario=${localStorage.getItem(
            "id",
          )}`;
        }
        const res = await axios.get(endpointPendientes);
        return res.data;
      } catch (error) {
        console.error("Error obteniendo casos pendientes:", error);
        return [];
      }
    },

    // Método para obtener casos asignados del usuario y colegas
    async obtenerCasosAsignados(areaUsuario) {
      try {
        let casos = [];

        // Obtener casos asignados del usuario
        const resAsignadosUsuario = await axios.get(
          `${
            env.endpoint
          }callcenter/incidentesasignados?id=${localStorage.getItem("id")}`,
        );
        casos = [...casos, ...resAsignadosUsuario.data];

        // Obtener casos de colegas con el mismo cargo
        const casosColegas = await this.obtenerCasosDeColegas(areaUsuario);
        casos = [...casos, ...casosColegas];

        // 🆕 Eliminar duplicados por cc_id_caso
        const casosUnicos = this.eliminarDuplicadosPorId(casos);

        return casosUnicos;
      } catch (error) {
        console.error("Error obteniendo casos asignados:", error);
        return [];
      }
    },

    // Método para obtener casos suspendidos
    async obtenerCasosSuspendidos() {
      try {
        const idCargo = localStorage.getItem("idCargo");
        let endpointSuspendidos;
        if (
          idCargo == "3" ||
          idCargo == "4" ||
          idCargo == "15" ||
          idCargo == "16" ||
          idCargo == "17" ||
          idCargo == "20" 
        ) {
          endpointSuspendidos = `${
            env.endpoint
          }callcenter/incidentesSuspendidosAreasEspeciales?idUsuario=${localStorage.getItem(
            "id",
          )}`;
        } else {
          endpointSuspendidos = `${
            env.endpoint
          }callcenter/incidentesSuspendidos?idUsuario=${localStorage.getItem(
            "id",
          )}&idCargo=${localStorage.getItem("idCargo")}`;
        }
        const res = await axios.get(endpointSuspendidos);
        return res.data;
      } catch (error) {
        console.error("Error obteniendo casos suspendidos:", error);
        return [];
      }
    },

    // Método para obtener casos cerrados del usuario y colegas
    async obtenerCasosCerrados(areaUsuario) {
      try {
        let casos = [];

        // Obtener casos cerrados del usuario
        const resCerradosUsuario = await axios.get(
          `${
            env.endpoint
          }callcenter/incidentescerrados?id=${localStorage.getItem("id")}`,
        );
        casos = [...casos, ...resCerradosUsuario.data];

        // Obtener casos de colegas con el mismo cargo
        const casosColegas = await this.obtenerCasosDeColegas(areaUsuario);
        casos = [...casos, ...casosColegas];

        // 🆕 Eliminar duplicados por cc_id_caso
        const casosUnicos = this.eliminarDuplicadosPorId(casos);

        return casosUnicos;
      } catch (error) {
        console.error("Error obteniendo casos cerrados:", error);
        return [];
      }
    },

    // Método para obtener casos de colegas con el mismo cargo
    async obtenerCasosDeColegas(areaUsuario) {
      try {
        const idCargo = localStorage.getItem("idCargo");
        const idUsuario = localStorage.getItem("id");
        let casosColegas = [];

        // Obtener especialistas con el mismo cargo
        const resEspecialistas = await axios.get(
          `${
            env.endpoint
          }callcenter/get_especialistas?idCargo=${idCargo}&idUsuario=${localStorage.getItem(
            "id",
          )}`,
          { timeout: 10000 }, // Timeout de 10 segundos
        );

        const especialistasMismoCargo = resEspecialistas.data
          .filter((esp) => esp.idUsuario != idUsuario)
          .map((esp) => esp.idUsuario);

        if (especialistasMismoCargo.length === 0) {
          return [];
        }

        // 🆕 LIMITAR A MÁXIMO 3 COLEGAS (no 5)
        const colegasLimitados = especialistasMismoCargo.slice(0, 3);

        // 🆕 Procesar de forma secuencial con mejor manejo de errores
        for (const idColega of colegasLimitados) {
          try {
            // Obtener casos asignados del compañero (con timeout)
            const resAsignados = await axios.get(
              `${env.endpoint}callcenter/incidentesasignados?id=${idColega}`,
              { timeout: 8000 }, // Timeout de 8 segundos
            );

            // Filtrar solo casos de área 1 o 2
            const casosAsignadosColega = resAsignados.data.filter(
              (caso) =>
                caso.cc_id_area_requerimiento == 1 ||
                caso.cc_id_area_requerimiento == 2,
            );
            casosColegas = [...casosColegas, ...casosAsignadosColega];

            // 🆕 COMENTAR TEMPORALMENTE LA OBTENCIÓN DE CASOS CERRADOS
            // Hasta que se arregle el endpoint incidentescerrados en el backend
            /*
                try {
                    const resCerrados = await axios.get(
                        `${env.endpoint}callcenter/incidentescerrados?id=${idColega}`,
                        { timeout: 8000 }
                    );
                    
                    const casosCerradosColega = resCerrados.data.filter(caso => 
                        caso.cc_id_area_requerimiento == 1 || caso.cc_id_area_requerimiento == 2
                    );
                    casosColegas = [...casosColegas, ...casosCerradosColega];
                } catch (errorCerrados) {
                    console.warn(`⚠️ Error obteniendo casos CERRADOS del compañero ${idColega}:`, errorCerrados.message);
                    // Continuar sin casos cerrados
                }
                */

            // 🆕 Delay más largo entre peticiones (300ms en lugar de 100ms)
            await new Promise((resolve) => setTimeout(resolve, 300));
          } catch (error) {
            console.warn(
              `⚠️ Error obteniendo casos del compañero ${idColega}:`,
              error.message,
            );
            // Continuar con el siguiente colega sin detener el proceso
            continue;
          }
        }

        // 🆕 Eliminar duplicados por ID de caso
        const casosUnicos = [];
        const idsVistos = new Set();

        for (const caso of casosColegas) {
          const idCasoStr = String(caso.cc_id_caso);
          if (!idsVistos.has(idCasoStr)) {
            idsVistos.add(idCasoStr);
            casosUnicos.push(caso);
          }
        }

        return casosUnicos;
      } catch (error) {
        console.error("Error obteniendo casos de colegas:", error);
        return [];
      }
    },

    // 🆕 Método auxiliar para eliminar duplicados por cc_id_caso
    eliminarDuplicadosPorId(casos) {
      const casosUnicos = [];
      const idsVistos = new Set();

      for (const caso of casos) {
        const idCaso = caso.cc_id_caso;
        // Normalizar el ID a string para comparación consistente
        const idCasoStr = String(idCaso);

        if (!idsVistos.has(idCasoStr)) {
          idsVistos.add(idCasoStr);
          casosUnicos.push(caso);
        }
      }

      return casosUnicos;
    },

    // Método para procesar los casos (normalización, colores, tiempos)
    async procesarCasos(casos) {
      // Procesar todos los casos obtenidos
      for (let i = 0; i < casos.length; i++) {
        // Normalizar el campo nombre_especialista
        if (!casos[i].nombre_especialista) {
          if (casos[i].nombre) {
            casos[i].nombre_especialista = casos[i].nombre;
          } else if (casos[i].especialista) {
            casos[i].nombre_especialista = casos[i].especialista;
          } else {
            casos[i].nombre_especialista = "SIN ASIGNAR";
          }
        }

        // Asignar colores según prioridad
        if (casos[i].cc_prioridad_requerimiento === "1") {
          casos[i].color = "green";
        } else if (casos[i].cc_prioridad_requerimiento === "2") {
          casos[i].color = "orange";
        } else {
          casos[i].color = "red";
        }

        // Normalizar cerrados y estado_caso a número
        casos[i].cerrados = Number(casos[i].cerrados);
        casos[i].estado_caso = Number(casos[i].cerrados);
      }

      // Hacer la petición de tiempos agrupados SOLO UNA VEZ
      const ids = casos.map((caso) => caso.cc_id_caso);
      let tiempos = [];
      if (ids.length > 0) {
        try {
          const resp = await axios.post(
            `${env.endpoint}callcenter/tiemposRestantes`,
            { ids },
          );
          if (resp.data.estado) {
            tiempos = resp.data.resultados;
          }
        } catch (e) {
          console.error("Error obteniendo tiempos agrupados:", e);
        }
      }

      // Asignar tiempos a cada caso
      for (let i = 0; i < casos.length; i++) {
        const tiempo = tiempos.find((t) => t.idCaso === casos[i].cc_id_caso);
        if (tiempo) {
          casos[i].tiempoRestanteBackend = tiempo.tiempo_restante;
          casos[i].tiempo_acumulado = tiempo.tiempo_acumulado || 0;
          casos[i].fecha_suspension = tiempo.fecha_suspension || null;
          casos[i].estado_caso = Number(tiempo.estado_caso);
        } else {
          // 🆕 Si no se encuentra tiempo, asegurar que estado_caso esté correctamente inicializado
          // Para casos pendientes (cerrados = 0), el estado_caso debe ser 0
          // Para casos asignados (cerrados = 2), el estado_caso debe ser 2
          casos[i].estado_caso = Number(casos[i].cerrados);
          // Si el caso está pendiente y no tiene tiempo calculado, inicializar tiempoRestanteBackend como null
          // para que el componente SemaforoTiempo lo maneje correctamente
          if (casos[i].cerrados === 0 && !casos[i].tiempoRestanteBackend) {
            casos[i].tiempoRestanteBackend = null;
          }
        }
      }

      // Ordenar casos: los más viejos arriba (ASC por fecha_inicio) y los más nuevos abajo
      casos.sort((a, b) => {
        const fA = a.fecha_inicio || "";
        const fB = b.fecha_inicio || "";
        return fA.localeCompare(fB);
      });

      this.casos = casos;
      // 🆕 Guardar copia original para el filtro
      this.casosOriginales = casos;
    },

    // Método para obtener las áreas desde la base de datos
    async obtenerAreas() {
      try {
        // 🆕 Si hay idEmpresaCaso, filtrar áreas por empresa del caso
        let url = `${env.endpoint}callcenter/areasConRequerimientos`;
        if (
          this.idEmpresaCaso &&
          (this.idEmpresaCaso === 1 || this.idEmpresaCaso === 2)
        ) {
          url += `?idEmpresa=${this.idEmpresaCaso}`;
        }

        const response = await axios.get(url);
        // Mapear los datos del endpoint al formato esperado
        this.areas = response.data.map((area) => ({
          idArea: String(area.cc_id_area),
          area: area.cc_nombre_area,
        }));
      } catch (error) {
        console.error("Error cargando áreas:", error);
        this.areas = [];
      }
    },
    // 🆕 Método para obtener el idArea del usuario
    async obtenerIdAreaUsuario() {
      try {
        const idUsuario = localStorage.getItem("id");
        const response = await axios.get(
          `${env.endpoint}user/infoUsuario?id=${idUsuario}`,
        );
        if (response.data && response.data.idArea) {
          this.idAreaUsuario = parseInt(response.data.idArea);
        }
      } catch (error) {
        console.error("Error obteniendo idArea del usuario:", error);
        // Si falla, intentar obtener desde localStorage
        const idArea = localStorage.getItem("idArea");
        if (idArea) {
          this.idAreaUsuario = parseInt(idArea);
        }
      }
    },

    // 🆕 Método para obtener el idEmpresa del usuario
    async obtenerIdEmpresaUsuario() {
      try {
        const idUsuario = localStorage.getItem("id");
        const response = await axios.get(
          `${env.endpoint}user/infoUsuario?id=${idUsuario}`,
        );
        if (response.data && response.data.idEmpresa) {
          this.idEmpresaUsuario = parseInt(response.data.idEmpresa);
        } else {
          console.warn("DEBUG: No se pudo obtener idEmpresa del usuario");
        }
      } catch (error) {
        console.error("Error obteniendo idEmpresa del usuario:", error);
      }
    },
    async llamarRequerimientos(idArea) {
      const index = this.areas.findIndex(
        (element) => element.idArea === idArea,
      );
      if (index !== -1) {
        this.editedItem.area = this.areas[index].area;
      }

      try {
        // Cargar requerimientos específicos del área
        const idUsuario = localStorage.getItem("id");
        // 🆕 Agregar idCaso si está disponible (cuando se está escalando un caso)
        const idCaso = this.idCaso || null;
        let url = `${env.endpoint}callcenter/requerimientosarea?idArea=${idArea}&idUsuario=${idUsuario}`;
        if (idCaso) {
          url += `&idCaso=${idCaso}`;
        }
        const response = await axios.get(url);
        this.requerimientos = response.data;
      } catch (error) {
        console.error("Error cargando requerimientos por área:", error);
        this.requerimientos = [];
      }
    },
    // NUEVO MÉTODO: Actualizar área cuando se selecciona un requerimiento
    actualizarAreaDesdeRequerimiento(idRequerimiento) {
      if (!idRequerimiento) return;

      // Buscar el requerimiento seleccionado en todos los requerimientos
      const requerimientoSeleccionado = this.todosRequerimientos.find(
        (req) => req.cc_id_requerimientos == idRequerimiento,
      );

      if (requerimientoSeleccionado) {
        // Obtener el área correcta del requerimiento (puede ser cc_id_area_requerimiento o cc_id_area)
        const idAreaRequerimiento =
          requerimientoSeleccionado.cc_id_area_requerimiento ||
          requerimientoSeleccionado.cc_id_area;

        if (idAreaRequerimiento) {
          // Buscar el área correspondiente en el array de áreas
          const areaCorrecta = this.areas.find(
            (area) => area.idArea == idAreaRequerimiento,
          );

          if (areaCorrecta) {
            // Actualizar el área seleccionada
            this.editedItem.idArea = areaCorrecta.idArea;
            this.editedItem.area = areaCorrecta.area;

            // Recargar los requerimientos de la nueva área para mantener consistencia
            this.llamarRequerimientos(areaCorrecta.idArea);

            // Mantener el requerimiento seleccionado
            this.$nextTick(() => {
              this.editedItem.requerimientos = idRequerimiento;
            });
          }
        }
      }
    },
    escalar(item) {
      this.dialog5 = true;
      this.fechaArea = item.fecha_area;
      this.idCaso = item.cc_id_caso;
      this.casoPendienteObj = item;

      // 🆕 Guardar idEmpresa del caso para filtrar áreas
      this.idEmpresaCaso = item.idEmpresa ? parseInt(item.idEmpresa) : null;

      // 🆕 Recargar áreas basadas en la empresa del caso
      this.obtenerAreas();
    },
    /**
     * Metodo para asignar casos
     */
    asignarCaso(item) {
      // 🆕 Validar si el usuario es líder
      // Si es líder: puede asignar a otros especialistas (dialog4)
      // Si NO es líder: solo puede auto-asignarse (dialog1)
      axios
        .get(
          `${env.endpoint}callcenter/validar_lider_area?idCargo=${this.idCargo}`,
        )
        .then((res) => {
          const esLiderValido = res.data.mensaje === "permite";
          // 🆕 Permitir también a líderes de Mesa de Servicios (cargo 22) y Sistemas (cargo 4) del área 1 o 2
          const idCargoNum = parseInt(this.idCargo);
          const esCargoLiderMesaServicios =
            idCargoNum === 22 || this.idCargo == "22";
          const esCargoLiderSistemas = idCargoNum === 4 || this.idCargo == "4";
          const esAreaMesaServiciosOSistemas =
            this.idAreaUsuario === 1 || this.idAreaUsuario === 2;

          const esLiderMesaServiciosOSistemas =
            (esCargoLiderMesaServicios || esCargoLiderSistemas) &&
            (esAreaMesaServiciosOSistemas ||
              this.idAreaUsuario === null ||
              this.idAreaUsuario === undefined);

          if (esLiderValido || esLiderMesaServiciosOSistemas) {
            // Es líder: cargar lista de especialistas y abrir modal de selección
            // Definimos los grupos de cargos según el área del usuario
            let cargos = [];

            // Si es líder de Mesa de Servicios (área 1), solo ver especialistas de Mesa de Servicios
            if (
              esCargoLiderMesaServicios &&
              (this.idAreaUsuario === 1 ||
                this.idAreaUsuario === null ||
                this.idAreaUsuario === undefined)
            ) {
              cargos = [21, 22]; // Solo Mesa de Servicios (agentes cargo 21 y líder cargo 22)
            }
            // Si es líder de Sistemas (área 2), solo ver especialistas de Sistemas
            else if (
              esCargoLiderSistemas &&
              (this.idAreaUsuario === 2 ||
                this.idAreaUsuario === null ||
                this.idAreaUsuario === undefined)
            ) {
              cargos = [4]; // Solo Sistemas
            }
            // Si es líder validado por el endpoint, usar grupos estándar
            else if (esLiderValido) {
              const grupos = {
                123: [123, 35],
                35: [123, 35],
                128: [128, 45],
                45: [128, 45],
              };
              cargos = grupos[this.idCargo] || [this.idCargo];
            }
            // Fallback: usar el cargo actual
            else {
              cargos = [this.idCargo];
            }

            axios
              .get(
                `${
                  env.endpoint
                }callcenter/get_especialistas?idCargo=${cargos.join(
                  ",",
                )}&idUsuario=${localStorage.getItem("id")}`,
              )
              .then((res) => {
                this.items = res.data && res.data.length > 0 ? res.data : [];
              })
              .catch((error) => {
                console.error("Error al consultar especialistas:", error);
                this.items = [];
              })
              .finally(() => {
                this.idCaso = item.cc_id_caso;
                this.dialog4 = true;
              });
          } else {
            // No es líder: auto-asignación
            this.editedIndex = this.casos.indexOf(item);
            this.idCaso = item.cc_id_caso;
            this.dialog1 = true;
          }
        })
        .catch((error) => {
          console.error("Error al validar líder:", error);
          // En caso de error, permitir auto-asignación
          this.editedIndex = this.casos.indexOf(item);
          this.idCaso = item.cc_id_caso;
          this.dialog1 = true;
        });
    },

    /**
     * Metodo para ver conversacion de casos
     */
    verConversacion(item) {
      this.dialog2 = true;
      this.idCasoActual = item.cc_id_caso;
      const data = JSON.parse(JSON.stringify(item));

      // Manejar diferentes estructuras de conversación
      let conversacion = null;

      // Verificar si existe el campo conversacion
      if (data.conversacion) {
        conversacion = data.conversacion;
      } else if (data.chat) {
        conversacion = data.chat;
      } else if (data.mensajes) {
        conversacion = data.mensajes;
      } else {
        // Si no hay conversación en los datos, intentar obtenerla desde la API
        this.obtenerConversacionDesdeAPI(item.cc_id_caso);
        return;
      }

      // Verificar si la conversación es un string JSON que necesita ser parseado
      if (typeof conversacion === "string") {
        try {
          conversacion = JSON.parse(conversacion);
        } catch (e) {
          console.error("Error parseando conversación:", e);
          // Si falla el parse, intentar obtener desde API
          this.obtenerConversacionDesdeAPI(item.cc_id_caso);
          return;
        }
      }

      // Verificar que conversacion sea un array
      if (!Array.isArray(conversacion)) {
        console.error("Conversación no es un array:", conversacion);
        // Si no es un array, intentar obtener desde API
        this.obtenerConversacionDesdeAPI(item.cc_id_caso);
        return;
      }

      this.chatItem = conversacion;
    },

    /**
     * Método para obtener conversación desde API cuando no está disponible en los datos
     */
    async obtenerConversacionDesdeAPI(idCaso) {
      try {
        // Intentar obtener el caso completo con conversación desde el endpoint de incidentes
        const response = await axios.get(
          `${
            env.endpoint
          }callcenter/incidentespendientes?idUsuario=${localStorage.getItem(
            "id",
          )}`,
        );

        // Buscar el caso específico en la respuesta
        const casoCompleto = response.data.find(
          (caso) => caso.cc_id_caso == idCaso,
        );

        if (casoCompleto && casoCompleto.conversacion) {
          let conversacion = casoCompleto.conversacion;

          // Verificar si la conversación es un string JSON que necesita ser parseado
          if (typeof conversacion === "string") {
            try {
              conversacion = JSON.parse(conversacion);
            } catch (e) {
              console.error("Error parseando conversación desde API:", e);
              conversacion = [];
            }
          }

          this.chatItem = conversacion;
        } else {
          // Intentar buscar en el endpoint de asignados
          try {
            const responseAsignados = await axios.get(
              `${
                env.endpoint
              }callcenter/incidentesasignados?id=${localStorage.getItem("id")}`,
            );
            const casoAsignado = responseAsignados.data.find(
              (caso) => caso.cc_id_caso == idCaso,
            );

            if (casoAsignado && casoAsignado.conversacion) {
              let conversacion = casoAsignado.conversacion;

              if (typeof conversacion === "string") {
                try {
                  conversacion = JSON.parse(conversacion);
                } catch (e) {
                  console.error(
                    "Error parseando conversación de asignados:",
                    e,
                  );
                  conversacion = [];
                }
              }

              this.chatItem = conversacion;
            } else {
              this.chatItem = [];
            }
          } catch (errorAsignados) {
            console.error("Error buscando en asignados:", errorAsignados);
            this.chatItem = [];
          }
        }
      } catch (error) {
        console.error("Error obteniendo conversación desde API:", error);
        this.chatItem = [];
        this.text = "Error al cargar la conversación";
        this.snackbar = true;
      }
    },

    /**
     * Metodo para cerrar caso
     */
    cerrarCaso(item) {
      this.idCaso = item.cc_id_caso;
      this.editedItem3.Observaciones = "";
      this.previewImages = [];
      this.selectedFiles = [];
      this.dialog3 = true;
    },

    /**
     * Metodo para cerrar la modal de asignar caso
     */
    close1() {
      this.dialog1 = false;
      this.editedIndex = -1;
    },

    /**
     * Metodo para cerrar la modal de ver conversacion
     */
    close2() {
      this.dialog2 = false;
      setTimeout(() => {
        this.editedItem = this.defaultItem;
        this.editedIndex = -1;
      }, 300);
    },
    close5() {
      this.dialog5 = false;
      this.editedItem.requerimientos = "";
      this.editedItem.idArea = "";
      this.editedItem.area = "";
      // 🆕 Limpiar idEmpresaCaso al cerrar el modal
      this.idEmpresaCaso = null;
      setTimeout(() => {
        this.editedItem = this.defaultItem;
        this.editedIndex = -1;
      }, 300);
      this.obtenerCasos();
    },
    /**
     * Metodo para cerrar la modal de cerrar caso
     */
    close3() {
      this.dialog3 = false;
      this.previewImages = [];
      this.selectedFiles = [];
      if (this.$refs && this.$refs.fileInput) this.$refs.fileInput.value = null;
      setTimeout(() => {
        this.idCaso = null;
        this.editedIndex = -1;
        this.editedItem3 = { Observaciones: "" };
      }, 300);
    },

    close4() {
      this.dialog4 = false;
      this.value = null;
      this.idCaso = null;
    },
    close6() {
      this.dialog6 = false;
      this.especialistaSeleccionado = null;
      this.observacionReasignacion = "";
    },
    /**
     * Metodo para guardar y actualizar - Asignar caso
     */
    save1(idCaso) {
      axios
        .get(
          `${env.endpoint}callcenter/asignar_caso?id=${localStorage.getItem(
            "id",
          )}&caso=${idCaso}`,
        )
        .then((res) => {
          if (res.data.mensaje === "caso asignado correctamente") {
            this.text = "Caso asignado correctamente";
            this.snackbar = true;

            // ACTUALIZACIÓN INMEDIATA: Actualizar el caso en la lista local
            const caso = this.casos.find((c) => c.cc_id_caso == idCaso);
            if (caso) {
              caso.nombre_especialista = this.nombre;
              caso.cerrados = 2; // Estado asignado
              caso.estado_caso = 2;
            }

            //registro historial
            axios.post(`${env.endpoint}historial/registrar_accion`, {
              cc_id_caso: idCaso,
              accion: 2, // 2 = Caso asignado (según tu modelo)
              idUsuario: localStorage.getItem("id"),
              observaciones: "", // O algún texto si lo deseas
            });
          } else {
            this.text = "Este caso ya ha sido asignado a otro especialista";
            this.snackbar = true;
          }
        });
      this.close1();

      // Actualización adicional después de un breve delay para sincronizar con el backend
      setTimeout(() => {
        this.obtenerCasos();
      }, 300);
    },

    /**
     * Metodo para guardar y actualizar - cerrar caso
     */
    save3(idCaso) {
      // Limpiar las observaciones antes de enviar
      const observacionesLimpias = this.sanitizeText(
        this.editedItem3.Observaciones,
      );

      const Observaciones = JSON.stringify({
        idEspecialista: localStorage.getItem("id"),
        cerrados: "1",
        oculto: "1",
        Observaciones: observacionesLimpias,
      });

      //SI ahi foto sube foto del cso
      this.uploadFilesMasivo(idCaso, this.selectedFiles);

      // Limpiar selección de archivos y previews luego de enviar
      this.selectedFiles = [];
      this.previewImages = [];
      if (this.$refs && this.$refs.fileInput) this.$refs.fileInput.value = null;

      axios
        .get(
          `${env.endpoint}callcenter/cerrar_caso?caso=${idCaso}&Observaciones=${Observaciones}`,
        )
        .then((res) => {
          if (res.data.mensaje === "caso cerrado correctamente") {
            this.text = "Caso cerrado correctamente";
            this.snackbar = true;

            // ACTUALIZACIÓN INMEDIATA: Remover el caso de la lista local
            this.casos = this.casos.filter((caso) => caso.cc_id_caso != idCaso);

            //registro historial
            axios.post(`${env.endpoint}historial/registrar_accion`, {
              cc_id_caso: idCaso,
              accion: 3, // 3 = Caso cerrado (según tu modelo)
              idUsuario: localStorage.getItem("id"),
              observaciones: observacionesLimpias,
            });
          } else {
            this.text = "No tienes permiso para cerrar este caso";
            this.snackbar = true;
          }
        });
      this.close3();

      // 🆕 SOLO recargar si estamos viendo la vista de cerrados
      // Ya actualizamos la lista local, no necesitamos recargar todo
      if (this.selectedFilter === "cerrados") {
        setTimeout(() => {
          this.obtenerCasos();
        }, 1000); // Delay más largo para dar tiempo al backend
      }
    },

    save4(idCaso) {
      axios
        .get(
          `${env.endpoint}callcenter/asignar_caso?id=${this.value}&caso=${idCaso}`,
        )
        .then((res) => {
          if (res.data.mensaje === "caso asignado correctamente") {
            this.text = "Caso asignado correctamente";
            this.snackbar = true;

            // ACTUALIZACIÓN INMEDIATA: Actualizar el caso en la lista local
            const caso = this.casos.find((c) => c.cc_id_caso == idCaso);
            if (caso) {
              // Buscar el nombre del usuario asignado
              const usuarioAsignado = this.items.find(
                (u) => u.idUsuario === this.value,
              );
              if (usuarioAsignado && usuarioAsignado.nombre) {
                caso.nombre_especialista = usuarioAsignado.nombre;
              } else {
                caso.nombre_especialista = this.value; // fallback
              }
              caso.cerrados = 2; // Estado asignado
              caso.estado_caso = 2;
            }

            // Registrar acción en historial con nombres
            const nombreAsignador = localStorage.getItem("nombre");
            // Buscar el nombre del usuario asignado
            let nombreAsignado = "";
            const usuarioAsignado = this.items.find(
              (u) => u.idUsuario === this.value,
            );
            if (usuarioAsignado && usuarioAsignado.nombre) {
              nombreAsignado = usuarioAsignado.nombre;
            } else {
              nombreAsignado = this.value; // fallback por si no se encuentra
            }
            const observacion = `se asignó el ticket a especialista ${nombreAsignado}`;
            axios.post(`${env.endpoint}historial/registrar_accion`, {
              cc_id_caso: idCaso,
              accion: 2, // 2 = Caso asignado
              idUsuario: localStorage.getItem("id"),
              observaciones: observacion,
            });
          } else {
            this.text = "Este caso ya ha sido asignado a otro especialista";
            this.snackbar = true;
          }
        })
        .finally(() => {
          this.close4();

          // Actualización adicional después de un breve delay para sincronizar con el backend
          setTimeout(() => {
            this.obtenerCasos();
          }, 300);
        });
    },
    save5(idCaso) {
      const caso = JSON.stringify({
        requerimiento: this.casoPendienteObj.cc_nombre_requerimiento,
        area: this.casoPendienteObj.cc_nombre_area,
        fechaArea: this.fechaArea,
      });

      // ✅ Obtener el idUsuario del localStorage
      const idUsuario = localStorage.getItem('id');

      axios
        .get(
          `${env.endpoint}callcenter/escalarCaso?idRequerimiento=${this.editedItem.requerimientos}&info=${caso}&idCaso=${idCaso}&idUsuario=${idUsuario}` // ✅ añadido &idUsuario
        )
        .then(() => {
          // Buscar el nombre del área seleccionado
          let nombreArea = "";
          const areaSeleccionada = this.areas.find(
            (a) => String(a.idArea) === String(this.editedItem.idArea),
          );
          if (areaSeleccionada && areaSeleccionada.area) {
            nombreArea = areaSeleccionada.area;
          } else if (this.editedItem.area) {
            nombreArea = this.editedItem.area;
          } else if (this.casoPendienteObj.cc_nombre_area) {
            nombreArea = this.casoPendienteObj.cc_nombre_area;
          } else {
            nombreArea = "No especificada";
          }

          // Buscar el nombre del requerimiento seleccionado
          let nombreRequerimiento = "";
          const reqSeleccionado = this.requerimientos.find(
            (r) =>
              String(r.cc_id_requerimientos) ===
              String(this.editedItem.requerimientos),
          );
          if (reqSeleccionado && reqSeleccionado.cc_nombre_requerimiento) {
            nombreRequerimiento = reqSeleccionado.cc_nombre_requerimiento;
          } else if (this.casoPendienteObj.cc_nombre_requerimiento) {
            nombreRequerimiento = this.casoPendienteObj.cc_nombre_requerimiento;
          } else {
            nombreRequerimiento = "No especificado";
          }

          // Registro en el historial de la acción de escalar caso
          // Obtener el área origen del caso
          let areaOrigen = "No especificada";
          if (this.casoPendienteObj && this.casoPendienteObj.cc_nombre_area) {
            areaOrigen = this.casoPendienteObj.cc_nombre_area;
          }
          const observaciones = `Caso escalado desde el área de ${areaOrigen} al área de ${nombreArea}`;
          axios
            .post(`${env.endpoint}historial/registrar_accion`, {
              cc_id_caso: idCaso,
              accion: 5, // 5 = Caso escalado
              idUsuario: localStorage.getItem("id"),
              observaciones: observaciones,
            })
            .catch((error) => {
              console.error("Error al registrar la acción de escalado:", error);
            });
          swal({
            title: "Caso escalado",
            text: "El caso fue escalado exitosamente",
            icon: "success",
            timer: 4000,
          });
        });
      this.close5();
    },
    /**
     * Método para obtener y mostrar las evidencias de un caso
     */
    verEvidencias(idCaso) {
      this.idCasoActual = idCaso;
      this.dialogEvidencias = true;
      this.cargandoEvidencias = false;
      this.evidencias = [];

      // endpoint para traer imagenes al modal chat
      axios
        .get(`${env.endpointTraerEvidencias}?cc_id_caso=${idCaso}`)
        .then((response) => {
          this.evidencias = response.data.evidencias;
          // console.log(response.data.evidencias);
        })
        .catch((error) => {
          console.error("Error al cargar evidencias:", error);
          this.text = "Error al cargar las evidencias";
          this.snackbar = true;
        })
        .finally(() => {
          this.cargandoEvidencias = false;
        });
    },

    /**
     * Método para cerrar el modal de evidencias
     */
    closeEvidencias() {
      this.dialogEvidencias = false;
      this.evidencias = [];
    },

    /**
     * Método para ver una imagen en pantalla completa
     */
    verImagenCompleta(url) {
      this.imagenSeleccionada = url;
      this.dialogImagenCompleta = true;
    },

    /**
     * Método para descargar la imagen seleccionada
     */
    descargarImagen() {
      this.downloadFile(this.imagenSeleccionada);
    },

    /**
     * Método para formatear la fecha de la evidencia
     */
    formatDate(dateString) {
      const options = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };
      return new Date(dateString).toLocaleDateString("es-ES", options);
    },

    cambiarEstado(item) {
      this.editedItem = { ...item };
      this.dialog6 = true;
      this.idCaso = item.cc_id_caso;
    },
    guardarEstado() {
      if (this.editedItem.estado === "REASIGNAR") {
        // Manejar reasignación desde el modal de cambiar estado
        if (!this.especialistaSeleccionado) {
          this.text = "Debe seleccionar un especialista";
          this.snackbar = true;
          return;
        }

        try {
          // Primero desasignar el caso actual
          axios
            .get(
              `${env.endpoint}callcenter/deshacerasignado?idCaso=${this.idCaso}`,
            )
            .then(async () => {
              // Luego asignar al nuevo especialista
              const res = await axios.get(
                `${env.endpoint}callcenter/asignar_caso?id=${this.especialistaSeleccionado}&caso=${this.idCaso}`,
              );

              if (res.data.mensaje === "caso asignado correctamente") {
                // Obtener nombre del especialista asignado
                const especialista = this.especialistasDisponibles.find(
                  (e) => e.idUsuario === this.especialistaSeleccionado,
                );
                const nombreEspecialista = especialista
                  ? especialista.nombre
                  : this.especialistaSeleccionado;

                // Limpiar observación antes de enviar
                const observacionLimpia = this.sanitizeText(
                  this.observacionReasignacion,
                );

                // Registrar en historial
                await axios.post(`${env.endpoint}historial/registrar_accion`, {
                  cc_id_caso: this.idCaso,
                  accion: 11, // Código para reasignación
                  idUsuario: localStorage.getItem("id"),
                  observaciones: `Caso reasignado a ${nombreEspecialista}. ${observacionLimpia}`,
                });

                this.text = `Caso reasignado correctamente a ${nombreEspecialista}`;
                this.snackbar = true;
                this.close6();
                this.obtenerCasos();
              } else {
                this.text = "Error al reasignar el caso";
                this.snackbar = true;
              }
            });
        } catch (error) {
          console.error("Error en reasignación:", error);
          this.text = "Error al reasignar el caso";
          this.snackbar = true;
        }
        return;
      } else if (this.editedItem.estado === "DESASIGNAR") {
        // Manejar desasignación
        const observacionLimpia = this.sanitizeText(
          this.observacionReasignacion,
        );
        try {
          axios
            .get(
              `${env.endpoint}callcenter/deshacerasignado?idCaso=${this.idCaso}`,
            )
            .then(async () => {
              await axios.post(`${env.endpoint}historial/registrar_accion`, {
                cc_id_caso: this.idCaso,
                accion: 9, // Código para desasignación
                idUsuario: localStorage.getItem("id"),
                observaciones: observacionLimpia,
              });
              this.text = "Caso desasignado correctamente";
              this.snackbar = true;
              this.close6();
              this.obtenerCasos();
            });
        } catch (error) {
          console.error("Error en desasignación:", error);
          this.text = "Error al desasignar el caso";
          this.snackbar = true;
        }
        return;
      }

      // Limpiar la observación antes de enviar
      const observacionLimpia = this.sanitizeText(this.editedItem.observacion);

      const estadosMap = {
        SUSPENDIDO: { estadoNumero: 3, accion: 6 },
        ANULADO: { estadoNumero: 5, accion: 8 },
        REACTIVAR: { estadoNumero: 2, accion: 4 },
      };

      const { estadoNumero, accion } = estadosMap[this.editedItem.estado];
      const observacion = encodeURIComponent(observacionLimpia || "");

      // Determinar si estamos reactivando un caso suspendido
      const esReactivacion = this.editedItem.estado === "REACTIVAR";

      // Para reactivaciones, añadir parámetro que indique al backend que debe reiniciar el contador de tiempo
      const urlEndpoint = esReactivacion
        ? `${env.endpoint}callcenter/cambiarEstado?idCaso=${this.idCaso}&cerrados=${estadoNumero}&observacion=${observacion}&reiniciarContador=1`
        : `${env.endpoint}callcenter/cambiarEstado?idCaso=${this.idCaso}&cerrados=${estadoNumero}&observacion=${observacion}`;

      axios
        .get(urlEndpoint)
        .then((res) => {
          if (res.data.estado) {
            this.text = "Estado cambiado correctamente";

            axios
              .post(`${env.endpoint}historial/registrar_accion`, {
                cc_id_caso: this.idCaso,
                accion: accion,
                idUsuario: localStorage.getItem("id"),
                observaciones: observacionLimpia || "",
              })
              .catch((error) => {
                console.error(
                  "Error al registrar la acción en el historial:",
                  error,
                );
              });

            // ACTUALIZACIÓN INMEDIATA: Buscar y actualizar el caso en la lista local
            const casoIndex = this.casos.findIndex(
              (c) => c.cc_id_caso == this.idCaso,
            );
            if (casoIndex !== -1) {
              // Actualizar el caso inmediatamente en la lista local
              this.casos[casoIndex].cerrados = estadoNumero;
              this.casos[casoIndex].estado_caso = estadoNumero;

              // Si el estado es ANULADO o SUSPENDIDO, remover el caso de la vista actual inmediatamente
              if (estadoNumero === 5 || estadoNumero === 3) {
                // Filtrar el caso de la lista para que desaparezca inmediatamente
                this.casos = this.casos.filter(
                  (c) => c.cc_id_caso != this.idCaso,
                );
              }

              // Si es reactivación, actualizar tiempo restante inmediatamente
              if (esReactivacion) {
                this.actualizarTiempoRestanteCaso(this.idCaso);
              }
            }

            // Actualización adicional después de un breve delay para sincronizar con el backend
            setTimeout(() => {
              // Solo actualizar la lista completa si es necesario
              if (estadoNumero === 5 || estadoNumero === 3) {
                // Para casos anulados o suspendidos, refrescar la lista para asegurar que no aparezcan
                this.obtenerCasos();
              } else if (esReactivacion) {
                // Para reactivaciones, actualizar tiempo restante y refrescar
                this.actualizarTiempoRestanteCaso(this.idCaso);
                setTimeout(() => {
                  this.obtenerCasos();
                }, 500);
              }
            }, 300);
          } else {
            this.text = "Este caso no pudo cambiar de estado";
          }
          this.snackbar = true;
          this.close6();
        })
        .catch((error) => {
          this.text = "Error al cambiar estado";
          this.snackbar = true;
          console.error(error);
        });
    },

    verHistorial(item) {
      this.idCasoActual = item.cc_id_caso;
      this.dialogHistorial = true;
    },

    /**
     * Maneja el evento cuando el estado de un caso cambia automáticamente a VENCIDO
     */
    handleCasoVencido({ idCaso, mensaje }) {
      this.text = mensaje;
      this.snackbar = false;
      // Buscar y actualizar el caso específico en la lista (normalizando a número)
      const caso = this.casos.find(
        (c) => Number(c.cc_id_caso) === Number(idCaso),
      );
      if (caso) {
        caso.cerrados = 4;
        caso.estado_caso = 4;
        setTimeout(() => {
          this.obtenerCasos();
        }, 1000);
      } else {
        this.obtenerCasos();
      }
    },

    async actualizarTiempoRestanteCaso(idCaso) {
      try {
        const resp = await axios.get(
          `${env.endpoint}callcenter/tiempoRestante?idCaso=${idCaso}`,
        );
        // Buscar el caso en la lista
        const caso = this.casos.find((c) => c.cc_id_caso == idCaso);
        if (caso) {
          // Actualizar todos los datos relevantes
          caso.tiempoRestanteBackend = resp.data.tiempo_restante;
          caso.tiempo_acumulado = resp.data.tiempo_acumulado;
          caso.fecha_suspension = resp.data.fecha_suspension;

          // Si el backend devuelve un valor para cerrados, actualizarlo
          if (resp.data.cerrados) {
            caso.cerrados = resp.data.cerrados;
            // Sincronizar el estado_caso con cerrados
            caso.estado_caso = resp.data.cerrados;
            // console.log(`Caso #${idCaso} - Estado actualizado en tiempo restante: ${caso.estado_caso}`);
          }
        }
        // Si el caso ya no está en la lista o ha cambiado de estado, refrescar toda la lista
        else {
          this.obtenerCasos();
        }
      } catch (e) {
        console.error("Error al actualizar tiempo restante:", e);
        // Si hay error, refrescar toda la lista para asegurar datos actualizados
        this.obtenerCasos();
      }
    },

    /**
     * Maneja el evento cuando el estado de un caso cambia automáticamente a VENCIDO
     */
    handleCasoVencido({ idCaso, mensaje }) {
      this.text = mensaje;
      this.snackbar = false;
      // Buscar y actualizar el caso específico en la lista (normalizando a número)
      const caso = this.casos.find(
        (c) => Number(c.cc_id_caso) === Number(idCaso),
      );
      if (caso) {
        caso.cerrados = 4;
        caso.estado_caso = 4;
        setTimeout(() => {
          this.obtenerCasos();
        }, 1000);
      } else {
        this.obtenerCasos();
      }
    },

    async cargarDiasFestivos() {
      try {
        const anioActual = new Date().getFullYear();
        const anioSiguiente = anioActual + 1;
        const respuestaActual = await axios.get(
          `https://date.nager.at/api/v3/publicholidays/${anioActual}/CO`,
        );
        const respuestaSiguiente = await axios.get(
          `https://date.nager.at/api/v3/publicholidays/${anioSiguiente}/CO`,
        );
        this.diasFestivos = [
          ...respuestaActual.data,
          ...respuestaSiguiente.data,
        ].map((festivo) => ({
          fecha: new Date(festivo.date + "T00:00:00"),
          nombre: festivo.name,
        }));
      } catch (error) {
        this.diasFestivos = [];
      }
    },
    async cargarEspecialistas() {
      try {
        this.cargandoEspecialistas = true;
        const res = await axios.get(
          `${env.endpoint}callcenter/get_especialistas?idCargo=${
            this.idCargo
          }&idUsuario=${localStorage.getItem("id")}`,
        );
        this.especialistasDisponibles = res.data;
      } catch (error) {
        console.error("Error al cargar especialistas:", error);
        this.especialistasDisponibles = [];
      } finally {
        this.cargandoEspecialistas = false;
      }
    },
    async abrirConfirmacionAsignacionMasiva() {
      // Validar si el usuario es líder
      try {
        const res = await axios.get(
          `${env.endpoint}callcenter/validar_lider_area?idCargo=${this.idCargo}`,
        );
        const esLiderValido = res.data.mensaje === "permite";
        // 🆕 Permitir también a líderes de Mesa de Servicios (cargo 22) y Sistemas (cargo 4) del área 1 o 2
        const idCargoNum = parseInt(this.idCargo);
        const esCargoLiderMesaServicios =
          idCargoNum === 22 || this.idCargo == "22";
        const esCargoLiderSistemas = idCargoNum === 4 || this.idCargo == "4";
        const esAreaMesaServiciosOSistemas =
          this.idAreaUsuario === 1 || this.idAreaUsuario === 2;

        const esLiderMesaServiciosOSistemas =
          (esCargoLiderMesaServicios || esCargoLiderSistemas) &&
          (esAreaMesaServiciosOSistemas ||
            this.idAreaUsuario === null ||
            this.idAreaUsuario === undefined);

        if (esLiderValido || esLiderMesaServiciosOSistemas) {
          // Si es líder, cargar la lista de especialistas
          // 🆕 Determinar cargos según el área del usuario
          let cargos = [];

          // Si es líder de Mesa de Servicios (área 1), solo ver especialistas de Mesa de Servicios
          if (
            esCargoLiderMesaServicios &&
            (this.idAreaUsuario === 1 ||
              this.idAreaUsuario === null ||
              this.idAreaUsuario === undefined)
          ) {
            cargos = [21, 22]; // Solo Mesa de Servicios (agentes cargo 21 y líder cargo 22)
          }
          // Si es líder de Sistemas (área 2), solo ver especialistas de Sistemas
          else if (
            esCargoLiderSistemas &&
            (this.idAreaUsuario === 2 ||
              this.idAreaUsuario === null ||
              this.idAreaUsuario === undefined)
          ) {
            cargos = [4]; // Solo Sistemas
          }
          // Si es líder validado por el endpoint, usar grupos estándar
          else if (esLiderValido) {
            const grupos = {
              123: [123, 35],
              35: [123, 35],
              128: [128, 45],
              45: [128, 45],
            };
            cargos = grupos[this.idCargo] || [this.idCargo];
          }
          // Fallback: usar el cargo actual
          else {
            cargos = [this.idCargo];
          }

          const resEspecialistas = await axios.get(
            `${env.endpoint}callcenter/get_especialistas?idCargo=${cargos.join(
              ",",
            )}&idUsuario=${localStorage.getItem("id")}`,
          );
          this.items =
            resEspecialistas.data && resEspecialistas.data.length > 0
              ? resEspecialistas.data
              : [];
          this.dialogAsignacionMasivaLider = true;
        } else {
          // Si no es líder, abrir modal normal de auto-asignación
          this.dialogConfirmarAsignacionMasiva = true;
        }
      } catch (error) {
        console.error("Error al validar líder:", error);
        // En caso de error, abrir modal normal
        this.dialogConfirmarAsignacionMasiva = true;
      }
    },
    async confirmarAsignacionMasiva() {
      this.dialogConfirmarAsignacionMasiva = false;
      // Aquí va la lógica de asignación masiva
      try {
        const ids = this.casosSeleccionados.map((caso) => caso.cc_id_caso);
        const payload = {
          ids,
          accion: "asignar",
          data: { idEspecialista: localStorage.getItem("id") },
        };
        const res = await axios.post(
          `${env.endpoint}callcenter/acciones_masivas`,
          payload,
        );
        if (res.data && res.data.resultados) {
          // 🆕 Separar casos exitosos de los que fallaron
          const casosExitosos = res.data.resultados.filter((r) => r.estado);
          const casosFallidos = res.data.resultados.filter((r) => !r.estado);

          // 🆕 Construir mensaje más claro
          let mensaje = "";
          if (casosExitosos.length > 0) {
            mensaje += `${casosExitosos.length} caso(s) asignado(s) correctamente. `;
          }
          if (casosFallidos.length > 0) {
            const idsFallidos = casosFallidos
              .map((r) => `#${r.idCaso}`)
              .join(", ");
            mensaje += `Error al asignar caso(s): ${idsFallidos}. `;
            mensaje += `Los casos pueden estar ya asignados, cerrados o no existen.`;
          }

          this.text = mensaje || "No se pudo procesar la asignación";
          this.snackbar = true;

          // REGISTRO HISTORIAL MASIVO
          res.data.resultados.forEach((r) => {
            if (r.estado) {
              axios.post(`${env.endpoint}historial/registrar_accion`, {
                cc_id_caso: r.idCaso,
                accion: 2, // 2 = Caso asignado (ajusta según la acción)
                idUsuario: localStorage.getItem("id"),
                observaciones: "", // O algún texto si lo deseas
              });
            }
          });

          this.casosSeleccionados = [];
          this.obtenerCasos();
        }
      } catch (error) {
        this.text = "Error al asignar casos";
        this.snackbar = true;
      }
    },
    abrirModalAccionMasiva() {
      this.accionSeleccionada = null;
      this.masivoObservaciones = "";
      this.masivoMotivo = "";
      this.previewImages = [];
      this.selectedFiles = [];
      this.esLider = false;
      this.mostrarConfirmacionAsignacion = false;
      this.especialistaSeleccionado = null;
      this.observacionReasignacion = "";
      this.dialogAccionMasiva = true;
    },
    cerrarModalAccionMasiva() {
      this.dialogAccionMasiva = false;
      this.accionSeleccionada = null;
      this.masivoObservaciones = "";
      this.masivoMotivo = "";
      this.previewImages = [];
      this.selectedFiles = [];
      this.mostrarConfirmacionAsignacion = false;
      this.especialistaSeleccionado = null;
      this.observacionReasignacion = "";
    },
    async seleccionarAccionMasiva(accion) {
      // Si la acción es asignar, validar si es líder
      if (accion === "asignar") {
        try {
          const res = await axios.get(
            `${env.endpoint}callcenter/validar_lider_area?idCargo=${this.idCargo}`,
          );

          if (res.data.mensaje === "permite") {
            // Si es líder, cargar la lista de especialistas y abrir modal de selección
            const resEspecialistas = await axios.get(
              `${env.endpoint}callcenter/get_especialistas?idCargo=${
                this.idCargo
              }&idUsuario=${localStorage.getItem("id")}`,
            );
            this.items = resEspecialistas.data;
            this.dialogAccionMasiva = false; // Cerrar modal de acciones masivas
            this.dialogAsignacionMasivaLider = true; // Abrir modal de líderes
            return;
          } else {
            // Si no es líder, establecer la propiedad esLider en false y mostrar confirmación
            this.esLider = false;
            this.mostrarConfirmacionAsignacion = true;
          }
        } catch (error) {
          console.error("Error al validar líder:", error);
          this.esLider = false;
          this.mostrarConfirmacionAsignacion = true;
        }
      }

      // Para otras acciones, continuar con el flujo normal
      this.accionSeleccionada = accion;
      this.masivoObservaciones = "";
      this.masivoMotivo = "";
      this.previewImages = [];
      this.selectedFiles = [];
      this.mostrarConfirmacionAsignacion = false;
    },
    async confirmarAccionMasiva() {
      if (this.accionSeleccionada === "reasignar") {
        // Manejar reasignación masiva
        if (!this.especialistaSeleccionado) {
          this.text = "Debe seleccionar un especialista para reasignar";
          this.snackbar = true;
          return;
        }

        const ids = this.casosSeleccionados.map((caso) => caso.cc_id_caso);
        const observacionLimpia = this.sanitizeText(
          this.observacionReasignacion,
        );
        const especialista = this.especialistasDisponibles.find(
          (e) => e.idUsuario === this.especialistaSeleccionado,
        );
        const nombreEspecialista = especialista
          ? especialista.nombre
          : this.especialistaSeleccionado;

        try {
          let resultados = [];
          for (const idCaso of ids) {
            try {
              // Primero desasignar el caso
              await axios.get(
                `${env.endpoint}callcenter/deshacerasignado?idCaso=${idCaso}`,
              );

              // Luego asignar al nuevo especialista
              const res = await axios.get(
                `${env.endpoint}callcenter/asignar_caso?id=${this.especialistaSeleccionado}&caso=${idCaso}`,
              );

              if (res.data.mensaje === "caso asignado correctamente") {
                // Registrar en historial
                await axios.post(`${env.endpoint}historial/registrar_accion`, {
                  cc_id_caso: idCaso,
                  accion: 11, // Código para reasignación
                  idUsuario: localStorage.getItem("id"),
                  observaciones: `Caso reasignado a ${nombreEspecialista}. ${observacionLimpia}`,
                });
                resultados.push({
                  idCaso,
                  estado: true,
                  mensaje: "Reasignado correctamente",
                });
              } else {
                resultados.push({
                  idCaso,
                  estado: false,
                  mensaje: "Error al reasignar",
                });
              }
            } catch (error) {
              resultados.push({
                idCaso,
                estado: false,
                mensaje: "Error en el proceso",
              });
            }
          }

          const exitosos = resultados.filter((r) => r.estado).length;
          const total = resultados.length;

          if (exitosos === total) {
            this.text = `Todos los casos (${total}) reasignados correctamente a ${nombreEspecialista}`;
          } else {
            this.text = `${exitosos} de ${total} casos reasignados correctamente a ${nombreEspecialista}`;
          }
          this.snackbar = true;
        } catch (error) {
          this.text = "Error en la reasignación masiva";
          this.snackbar = true;
        }

        // Limpiar archivos seleccionados y previews después de la reasignación masiva
        this.selectedFiles = [];
        this.previewImages = [];
        if (this.$refs && this.$refs.fileInput) this.$refs.fileInput.value = null;

        this.dialogAccionMasiva = false;
        this.casosSeleccionados = [];
        this.especialistaSeleccionado = null;
        this.observacionReasignacion = "";
        this.obtenerCasos();
        return;
      }

      this.dialogAccionMasiva = false;
      try {
        const ids = this.casosSeleccionados.map((caso) => caso.cc_id_caso);
        let payload = {
          ids,
          accion: this.accionSeleccionada,
          data: {},
        };

        if (this.accionSeleccionada === "cerrar") {
          // Limpiar observaciones masivas antes de enviar
          const observacionesLimpias = this.sanitizeText(
            this.masivoObservaciones,
          );
          payload.data = {
            observaciones: observacionesLimpias,
            idEspecialista: localStorage.getItem("id"),
            bandera: 0,
            oculto: 1,
            cerrados: 1,
          };
        } else if (this.accionSeleccionada === "asignar") {
          // Asignar casos al usuario actual
          payload.data = {
            idEspecialista: localStorage.getItem("id"),
          };
        } else if (this.accionSeleccionada === "suspender") {
          // Limpiar motivo antes de enviar
          const motivoLimpio = this.sanitizeText(this.masivoMotivo);
          payload.data = {
            motivo: motivoLimpio,
            fecha_suspension: new Date()
              .toISOString()
              .slice(0, 19)
              .replace("T", " "),
            idUsuario: localStorage.getItem("id"), // 🆕 Pasar idUsuario para asignar especialista si no tiene
          };
        } else if (this.accionSeleccionada === "anular") {
          // Limpiar motivo antes de enviar
          const motivoLimpio = this.sanitizeText(this.masivoMotivo);
          payload.data = {
            motivo: motivoLimpio,
          };
        }

        // desasignar no requiere data extra
        try {
          const res = await axios.post(
            `${env.endpoint}callcenter/acciones_masivas`,
            payload,
          );
          if (res.data && res.data.resultados) {
            // 🆕 Separar casos exitosos de los que fallaron
            const casosExitosos = res.data.resultados.filter((r) => r.estado);
            const casosFallidos = res.data.resultados.filter((r) => !r.estado);

            if (this.accionSeleccionada === "asignar") {
              // 🆕 Construir mensaje más claro para asignación
              let mensaje = "";
              if (casosExitosos.length > 0) {
                mensaje += `${casosExitosos.length} caso(s) asignado(s) correctamente. `;
              }
              if (casosFallidos.length > 0) {
                const idsFallidos = casosFallidos
                  .map((r) => `#${r.idCaso}`)
                  .join(", ");
                mensaje += `Error al asignar caso(s): ${idsFallidos}. `;
                mensaje += `Los casos pueden estar ya asignados, cerrados o no existen.`;
              }
              this.text = mensaje || "No se pudo procesar la asignación";
            } else if (this.accionSeleccionada === "desasignar") {
              // 🆕 Construir mensaje más claro para desasignación
              let mensaje = "";
              if (casosExitosos.length > 0) {
                mensaje += `${casosExitosos.length} caso(s) desasignado(s) correctamente. `;
              }
              if (casosFallidos.length > 0) {
                const idsFallidos = casosFallidos
                  .map((r) => `#${r.idCaso}`)
                  .join(", ");
                mensaje += `Error al desasignar caso(s): ${idsFallidos}. `;
                mensaje += `Los casos pueden no estar asignados o no existen.`;
              }
              this.text = mensaje || "No se pudo procesar la desasignación";
            } else {
              // 🆕 Construir mensaje más claro para otras acciones
              let mensaje = "";
              if (casosExitosos.length > 0) {
                mensaje += `${casosExitosos.length} caso(s) procesado(s) correctamente. `;
              }
              if (casosFallidos.length > 0) {
                const idsFallidos = casosFallidos
                  .map((r) => `#${r.idCaso}`)
                  .join(", ");
                mensaje += `Error en caso(s): ${idsFallidos}. `;
                mensaje += `Los casos pueden no estar en el estado correcto o no existen.`;
              }
              this.text = mensaje || "No se pudo procesar la acción";
            }
            this.snackbar = true;

            // REGISTRO HISTORIAL MASIVO
            let codigoAccionHistorial = 0;
            if (this.accionSeleccionada === "asignar")
              codigoAccionHistorial = 2;
            if (this.accionSeleccionada === "desasignar")
              codigoAccionHistorial = 9;
            if (this.accionSeleccionada === "cerrar") codigoAccionHistorial = 3;
            if (this.accionSeleccionada === "suspender")
              codigoAccionHistorial = 6;
            if (this.accionSeleccionada === "anular") codigoAccionHistorial = 8;

            // Copiar los archivos seleccionados antes de iterar
            const filesToUpload = [...this.selectedFiles];
            res.data.resultados.forEach((r) => {
              if (r.estado) {
                let observacionesParaHistorial = "";
                if (this.accionSeleccionada === "cerrar") {
                  observacionesParaHistorial = this.sanitizeText(
                    this.masivoObservaciones,
                  );
                } else if (this.accionSeleccionada === "asignar") {
                  observacionesParaHistorial = "Caso asignado masivamente";
                } else {
                  observacionesParaHistorial = this.sanitizeText(
                    this.masivoMotivo,
                  );
                }

                axios.post(`${env.endpoint}historial/registrar_accion`, {
                  cc_id_caso: r.idCaso,
                  accion: codigoAccionHistorial,
                  idUsuario: localStorage.getItem("id"),
                  observaciones: observacionesParaHistorial,
                });
                // Subir archivos si la acción es cerrar y hay seleccionados
                if (
                  this.accionSeleccionada === "cerrar" &&
                  filesToUpload.length
                ) {
                  this.uploadFilesMasivo(r.idCaso, filesToUpload);
                }
              }
            });
            // ACTUALIZACIÓN INMEDIATA: Remover casos procesados de la lista local
            if (
              this.accionSeleccionada === "cerrar" ||
              this.accionSeleccionada === "anular" ||
              this.accionSeleccionada === "suspender"
            ) {
              // Para estas acciones, los casos deben desaparecer de la vista actual
              const idsProcesados = res.data.resultados
                .filter((r) => r.estado)
                .map((r) => r.idCaso);

              // Filtrar los casos procesados exitosamente de la lista local
              this.casos = this.casos.filter(
                (caso) => !idsProcesados.includes(caso.cc_id_caso),
              );
            } else if (this.accionSeleccionada === "asignar") {
              // Para asignación, actualizar el estado de los casos asignados exitosamente
              res.data.resultados.forEach((r) => {
                if (r.estado) {
                  const caso = this.casos.find((c) => c.cc_id_caso == r.idCaso);
                  if (caso) {
                    caso.nombre_especialista = this.nombre;
                    caso.cerrados = 2; // Estado asignado
                    caso.estado_caso = 2;
                  }
                }
              });
            } else if (this.accionSeleccionada === "desasignar") {
              // Para desasignación, actualizar el estado de los casos desasignados exitosamente
              res.data.resultados.forEach((r) => {
                if (r.estado) {
                  const caso = this.casos.find((c) => c.cc_id_caso == r.idCaso);
                  if (caso) {
                    caso.nombre_especialista = "SIN ASIGNAR";
                    caso.cerrados = 0; // Estado pendiente
                    caso.estado_caso = 0;
                  }
                }
              });
            }

            // Limpiar archivos seleccionados y previews después de la acción masiva
            this.selectedFiles = [];
            this.previewImages = [];
            if (this.$refs && this.$refs.fileInput) this.$refs.fileInput.value = null;

            this.dialogAccionMasiva = false;
            this.casosSeleccionados = [];

            // Actualización adicional después de un breve delay para sincronizar con el backend
            setTimeout(() => {
              this.obtenerCasos();
            }, 500);
          }
        } catch (error) {
          console.error("Error en acciones masivas:", error);
          this.text = "Error en la acción masiva: " + (error.message || "error desconocido");
          this.snackbar = true;
        }
      } catch (error) {
        console.error("Error al realizar la acción masiva:", error);
        this.text = "Error al realizar la acción masiva";
        this.snackbar = true;
      }
    },
    closeDesasignar() {
      this.dialogDesasignar = false;
    },
    async confirmarDesasignar() {
      this.dialogDesasignar = false;
      try {
        const ids = [this.casoSeleccionado.cc_id_caso];
        const payload = {
          ids,
          accion: "desasignar",
          idEspecialista: localStorage.getItem("id"),
        };
        const res = await axios.post(
          `${env.endpoint}callcenter/acciones_masivas`,
          payload,
        );
        if (res.data && res.data.resultados) {
          let mensaje = res.data.resultados
            .map((r) => `Caso #${r.idCaso}: ${r.mensaje}`)
            .join("\n");
          this.text = mensaje;
          this.snackbar = true;

          // REGISTRO HISTORIAL MASIVO
          res.data.resultados.forEach((r) => {
            if (r.estado) {
              axios.post(`${env.endpoint}historial/registrar_accion`, {
                cc_id_caso: r.idCaso,
                accion: 9, // Código para desasignación
                idUsuario: localStorage.getItem("id"),
                observaciones: r.observaciones || "",
              });
            }
          });

          this.casosSeleccionados = [];
          this.obtenerCasos();
        }
      } catch (error) {
        this.text = "Error al desasignar el caso";
        this.snackbar = true;
      }
    },
    // Función para limpiar texto de caracteres especiales y emojis
    sanitizeText(text) {
      if (!text) return "";

      return (
        text
          // Remover emojis y símbolos especiales
          .replace(
            /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]/gu,
            "",
          )
          // Remover otros caracteres especiales pero mantener acentos y ñ
          .replace(/[^\w\s\u00C0-\u017F.,;:()\-\[\]]/g, "")
          // Normalizar espacios múltiples
          .replace(/\s+/g, " ")
          // Trim espacios al inicio y final
          .trim()
      );
    },

    abrirAgregarObservacion(item) {
      this.casoSeleccionado = item;
      this.nuevaObservacion = "";
      this.dialogAgregarObservacion = true;
    },
    async guardarObservacion() {
      if (!this.nuevaObservacion.trim()) return;
      await axios.post(`${env.endpoint}historial/registrar_accion`, {
        cc_id_caso: this.casoSeleccionado.cc_id_caso,
        accion: 10, // Código para observación libre
        idUsuario: localStorage.getItem("id"),
        observaciones: this.nuevaObservacion,
      });
      this.dialogAgregarObservacion = false;
      this.text = "Observación guardada";
      this.snackbar = true;
    },
    verHistorialObservaciones(item) {
      this.idCasoActual = item.cc_id_caso;
      this.dialogHistorialObservaciones = true;
    },

    // Método para cerrar la modal de asignación masiva de líderes
    closeAsignacionMasivaLider() {
      this.dialogAsignacionMasivaLider = false;
      this.especialistaSeleccionadoMasivo = null;
    },

    // Método para confirmar asignación masiva de líderes
    async confirmarAsignacionMasivaLider() {
      this.dialogAsignacionMasivaLider = false;

      try {
        const ids = this.casosSeleccionados.map((caso) => caso.cc_id_caso);
        const payload = {
          ids,
          accion: "asignar",
          data: { idEspecialista: this.especialistaSeleccionadoMasivo },
        };

        const res = await axios.post(
          `${env.endpoint}callcenter/acciones_masivas`,
          payload,
        );

        if (res.data && res.data.resultados) {
          // 🆕 Separar casos exitosos de los que fallaron
          const casosExitosos = res.data.resultados.filter((r) => r.estado);
          const casosFallidos = res.data.resultados.filter((r) => !r.estado);

          // Buscar el nombre del especialista asignado
          let nombreEspecialista = "";
          const especialista = this.items.find(
            (u) => u.idUsuario === this.especialistaSeleccionadoMasivo,
          );
          if (especialista && especialista.nombre) {
            nombreEspecialista = especialista.nombre;
          } else {
            nombreEspecialista = this.especialistaSeleccionadoMasivo;
          }

          // 🆕 Construir mensaje más claro
          let mensaje = "";
          if (casosExitosos.length > 0) {
            mensaje += `${casosExitosos.length} caso(s) asignado(s) correctamente a ${nombreEspecialista}. `;
          }
          if (casosFallidos.length > 0) {
            const idsFallidos = casosFallidos
              .map((r) => `#${r.idCaso}`)
              .join(", ");
            mensaje += `Error al asignar caso(s): ${idsFallidos}. `;
            mensaje += `Los casos pueden estar ya asignados, cerrados o no existen.`;
          }

          this.text = mensaje || "No se pudo procesar la asignación";
          this.snackbar = true;

          // ACTUALIZACIÓN INMEDIATA: Actualizar el estado de los casos asignados exitosamente
          res.data.resultados.forEach((r) => {
            if (r.estado) {
              const caso = this.casos.find((c) => c.cc_id_caso == r.idCaso);
              if (caso) {
                caso.nombre_especialista = nombreEspecialista;
                caso.cerrados = 2; // Estado asignado
                caso.estado_caso = 2;
              }
            }
          });

          // REGISTRO HISTORIAL MASIVO
          res.data.resultados.forEach((r) => {
            if (r.estado) {
              const observacion = `se asignó el ticket a especialista ${nombreEspecialista}`;
              axios.post(`${env.endpoint}historial/registrar_accion`, {
                cc_id_caso: r.idCaso,
                accion: 2, // 2 = Caso asignado
                idUsuario: localStorage.getItem("id"),
                observaciones: observacion,
              });
            }
          });

          this.casosSeleccionados = [];
          this.especialistaSeleccionadoMasivo = null;

          // Actualización adicional después de un breve delay para sincronizar con el backend
          setTimeout(() => {
            this.obtenerCasos();
          }, 300);
        }
      } catch (error) {
        console.error("Error en asignación masiva de líder:", error);
        this.text = "Error al asignar casos";
        this.snackbar = true;
      }
    },
    handleDropMultiple(event) {
      event.preventDefault();
      const files = Array.from(event.dataTransfer.files || []);
      if (files.length) this.addFiles(files);
    },
    handlePasteMultiple(event) {
      event.preventDefault();
      const clipboard = event.clipboardData || (event.originalEvent && event.originalEvent.clipboardData);
      if (!clipboard) return;
      const files = [];
      for (const item of clipboard.items) {
        if (item.kind === "file") {
          const file = item.getAsFile();
          if (file) files.push(file);
        }
      }
      if (files.length) this.addFiles(files);
    },
    handleFileChangeMultiple() {
      const files = Array.from(this.$refs.fileInput.files || []);
      if (files.length) this.addFiles(files);
    },
    isImageFile(file) {
      const imageExtensions = [
        ".jpg",
        ".jpeg",
        ".png",
        ".gif",
        ".webp",
        ".svg",
      ];
      return imageExtensions.some((ext) =>
        file.name.toLowerCase().endsWith(ext),
      );
    },
    addFiles(files) {
      // Limitar a máximo 5 archivos
      const total = this.selectedFiles.length + files.length;
      let filesToAdd = files;
      if (total > 5) {
        const allowed = 5 - this.selectedFiles.length;
        filesToAdd = files.slice(0, allowed);
        this.text = "Solo puedes subir hasta 5 archivos.";
        this.snackbar = true;
      }
      filesToAdd.forEach((file) => {
        if (this.isImageFile(file)) {
          const reader = new FileReader();
          reader.onload = (event) => {
            this.previewImages.push(event.target.result);
          };
          reader.readAsDataURL(file);
        }
        this.selectedFiles.push(file);
      });
    },

    uploadFilesMasivo(idCaso, files) {
      if (files && files.length > 0) {
        const formData = new FormData();
        for (let i = 0; i < files.length; i++) {
          formData.append("evidencias[]", files[i]);
        }
        formData.append("cc_id_caso", idCaso);
        axios
          .post(`${env.endpointEvidenciasCaso}`, formData)
          .then((response) => {
            // archivos subidos
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },

    // Método para obtener el título dinámico según el filtro
    getTituloVista() {
      switch (this.selectedFilter) {
        case "tickets":
          return "TODOS LOS TICKETS";
        case "pendientes":
          return "CASOS PENDIENTES";
        case "asignados":
          return "CASOS ASIGNADOS";
        case "suspendidos":
          return "CASOS SUSPENDIDOS";
        case "cerrados":
          return "CASOS CERRADOS";
        default:
          return "TODOS LOS TICKETS";
      }
    },

    // Método para obtener el label de búsqueda dinámico
    getLabelBusqueda() {
      switch (this.selectedFilter) {
        case "tickets":
          return "Buscar en todos los casos";
        case "pendientes":
          return "Buscar caso pendiente";
        case "asignados":
          return "Buscar caso asignado";
        case "suspendidos":
          return "Buscar caso suspendido";
        case "cerrados":
          return "Buscar caso cerrado";
        default:
          return "Buscar caso";
      }
    },
    /**
     * Método para desasignar un caso individual
     */
    desasignarCaso(item) {
      this.idCaso = item.cc_id_caso;
      this.dialogDesasignar = true;
    },

    /**
     * Método para cerrar el modal de desasignación individual
     */
    closeDesasignar() {
      this.dialogDesasignar = false;
      this.idCaso = null;
    },

    /**
     * Método para confirmar la desasignación individual
     */
    confirmarDesasignar() {
      axios
        .get(`${env.endpoint}callcenter/deshacerasignado?idCaso=${this.idCaso}`)
        .then((res) => {
          if (res.data.mensaje === "deshacer asignado exitoso") {
            this.text = "Desasignación de caso completado";
            this.snackbar = true;

            // ACTUALIZACIÓN INMEDIATA: Actualizar el caso en la lista local
            const caso = this.casos.find((c) => c.cc_id_caso == this.idCaso);
            if (caso) {
              caso.nombre_especialista = "SIN ASIGNAR";
              caso.cerrados = 0; // Estado pendiente
              caso.estado_caso = 0;
            }

            // Registrar en historial
            axios.post(`${env.endpoint}historial/registrar_accion`, {
              cc_id_caso: this.idCaso,
              accion: 9, // 9 = Desasignación de caso
              idUsuario: localStorage.getItem("id"),
              observaciones: "",
            });
          } else {
            this.text = "Error en deshacer la asignación";
            this.snackbar = true;
          }
        })
        .catch((error) => {
          console.error("Error al desasignar:", error);
          this.text = "Error al desasignar el caso";
          this.snackbar = true;
        });

      this.closeDesasignar();

      // Actualización adicional después de un breve delay para sincronizar con el backend
      setTimeout(() => {
        this.obtenerCasos();
      }, 300);
    },

    /**
     * Método para determinar si un caso puede ser seleccionado
     */
    isSelectable(item) {
      // Solo permitir selección si el caso está en el estado correcto
      const estadoCaso = this.getEstadoCaso(item);
      return estadoCaso !== null;
    },

    /**
     * Método para obtener la clase CSS del item según su estado
     */
    getItemClass(item) {
      const estadoCaso = this.getEstadoCaso(item);
      if (estadoCaso === null) {
        return "caso-no-seleccionable";
      }
      return `caso-${estadoCaso}`;
    },

    /**
     * Método para determinar el estado del caso para selección
     */
    getEstadoCaso(item) {
      // Casos pendientes (sin asignar)
      if (
        item.nombre_especialista === "SIN ASIGNAR" ||
        item.nombre_especialista === null
      ) {
        return "pendiente";
      }

      // Casos asignados al usuario actual
      if (item.nombre_especialista === this.nombre) {
        return "asignado";
      }

      // Casos asignados a otros usuarios
      if (
        item.nombre_especialista &&
        item.nombre_especialista !== this.nombre
      ) {
        return "asignado-otro";
      }

      // Si no se puede determinar el estado, no permitir selección
      return null;
    },

    /**
     * Método para verificar si todos los casos seleccionados tienen el mismo estado
     */
    verificarEstadosSeleccionados() {
      if (this.casosSeleccionados.length === 0) return null;

      const estados = this.casosSeleccionados.map((caso) =>
        this.getEstadoCaso(caso),
      );
      const estadoUnico = estados[0];

      // Verificar si todos tienen el mismo estado
      const todosIguales = estados.every((estado) => estado === estadoUnico);

      if (todosIguales) {
        return estadoUnico;
      }

      return "mixto";
    },

    /**
     * Método para obtener las acciones disponibles según el estado de los casos seleccionados
     */
    getAccionesDisponibles() {
      const estadoSeleccionado = this.verificarEstadosSeleccionados();

      if (!estadoSeleccionado || estadoSeleccionado === "mixto") {
        return [];
      }

      const accionesPorEstado = {
        pendiente: ["asignar"],
        asignado: ["cerrar", "suspender", "anular", "desasignar", "reasignar"],
        "asignado-otro": ["desasignar"], // Solo desasignar para casos de otros
      };

      return accionesPorEstado[estadoSeleccionado] || [];
    },
  },
};
</script>
<style>
.dialogAsesor .div-icon {
  background: blue;
  height: 80px;
  width: 80px;
}
/* Inicio estilos para ingreso de imagens Jempoder*/
#drop-area {
  border: 2px dashed #111c3d;
  padding: 20px;
  text-align: center;
  margin-top: 10px;
  cursor: pointer;
}

#drop-area:hover {
  background-color: #f0f0f0;
}

#drop-area img {
  max-width: 100%;
  max-height: 200px;
  margin-bottom: 10px;
}

.upload-button {
  background-color: #1d3c7f;
  color: whitesmoke;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  margin-top: 10px;
  border-radius: 5px;
}

.upload-button:hover {
  background-color: #152a5e;
}

.send-button {
  background-color: #008cba;
  color: white;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  border: none;
  border-radius: 5px;
  margin-top: 10px;
}

.send-button:hover {
  background-color: #0074a8;
}

.send-button:disabled {
  background-color: #d3d3d3;
  cursor: not-allowed;
}
/* FIN estilos para ingreso de imagens Jempoder*/

.asignar-masivo-btn {
  border-radius: 8px;
  letter-spacing: 1px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  margin-bottom: 8px;
}

.acciones-masivas-btn {
  border-radius: 8px;
  letter-spacing: 1px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  margin-bottom: 8px;
}

.acciones-masivas-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 16px 0 0 10px;
  justify-content: flex-start;
}

.accion-masiva-opcion {
  min-width: 150px;
  font-weight: bold;
  font-size: 16px;
  border-radius: 8px;
  transition: box-shadow 0.2s;
}

.accion-masiva-opcion--active {
  box-shadow: 0 0 0 3px #3945d0;
  background: #fffbe6 !important;
}

.headline {
  background-color: #1d3c7f;
  color: white;
  padding: 10px 16px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 1.1rem;
  font-weight: 600;
}

.chat-message {
  word-break: break-word;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  max-width: 100%;
}

@media (max-width: 599px) {
  .update-btn {
    min-width: auto !important;
    width: 40px !important;
    height: 40px !important;
    padding: 0 !important;
  }
}

/* Estilos para el botón de filtro en móvil */
.filter-icon-btn {
  color: #1d3c7f !important;
  align-self: center !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.filter-icon-btn:hover {
  background-color: rgba(29, 60, 127, 0.1) !important;
}

/* Asegurar que el botón de filtro esté bien alineado */
@media (max-width: 599px) {
  .filter-icon-btn {
    height: 40px !important;
    width: 40px !important;
    align-self: center !important;
  }

  .filter-container {
    display: flex !important;
    align-items: center !important;
    height: 100% !important;
  }
}

/* Estilos responsive solo para pantallas pequeñas */
@media (max-width: 960px) {
  .v-toolbar .icon {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .v-toolbar .icon .v-icon {
    transition: all 0.3s ease !important;
  }

  .v-toolbar .usuario {
    font-weight: bold !important;
    transition: all 0.3s ease !important;
    white-space: nowrap !important;
  }
}

/* Responsive para móvil */
@media (max-width: 599px) {
  .v-toolbar .icon {
    min-width: 40px !important;
    max-width: 40px !important;
    height: 40px !important;
  }

  .v-toolbar .icon .v-icon {
    font-size: 20px !important;
    margin-left: 8px !important;
    margin-top: 0 !important;
  }

  .v-toolbar .usuario {
    font-size: 14px !important;
    margin-left: 8px !important;
  }

  .v-toolbar .update-btn {
    margin-left: 8px !important;
    min-width: 40px !important;
    height: 40px !important;
    padding: 0 !important;
  }
}

/* Responsive para pantallas medianas (tablet) */
@media (min-width: 600px) and (max-width: 960px) {
  .v-toolbar .update-btn {
    margin-left: 8px !important;
    min-width: auto !important;
    padding: 0 12px !important;
    font-size: 12px !important;
  }

  .v-toolbar .update-btn .v-btn__content {
    padding: 0 8px !important;
  }
}

/* Responsive para tablet */
@media (min-width: 600px) and (max-width: 960px) {
  .v-toolbar .icon {
    min-width: 50px !important;
    max-width: 50px !important;
    height: 50px !important;
  }

  .v-toolbar .icon .v-icon {
    font-size: 24px !important;
    margin-left: 15px !important;
    margin-top: 12px !important;
  }

  .v-toolbar .usuario {
    font-size: 16px !important;
    margin-left: 12px !important;
  }
}

.offset-half {
  max-width: 98%;
  margin: 15px 1.2rem;
}

@media (max-width: 599px) {
  .offset-half {
    max-width: 98%;
    margin: 10px 6vw;
  }
}

/* Estilos para casos no seleccionables */
.caso-no-seleccionable {
  opacity: 0.6;
  background-color: #f5f5f5;
}

.caso-no-seleccionable .v-data-table__checkbox {
  pointer-events: none;
}

/* Estilos para diferentes estados de casos */
/* .caso-pendiente {
        background-color: #fff3e0;
    }
    
    .caso-asignado {
        background-color: #e8f5e8;
    }
    
    .caso-asignado-otro {
        background-color: #e5eef5;
    } */
</style>
